
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("5lkNm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $4368e6bbcdf8aa56$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673"/>
</svg>
`;
const $4368e6bbcdf8aa56$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135"/>
</svg>
`;
const $4368e6bbcdf8aa56$export$68f3db7f6af48bcb = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ConfluenceIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Confluence" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $4368e6bbcdf8aa56$var$svg,
            customThemeSvg: $4368e6bbcdf8aa56$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function ConfluenceIcon({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Confluence', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $4368e6bbcdf8aa56$var$svg,
        customThemeSvg: $4368e6bbcdf8aa56$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["ConfluenceIcon"] = $4368e6bbcdf8aa56$export$68f3db7f6af48bcb;

});

parcelRegister("6YXrY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $8993de4d80c5f842$export$e30d2ddc605f6bb = (_LegacyComponent, NewComponent)=>{
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return ({ size: size, shouldUseNewLogoDesign: _shouldUseNewLogoDesign, ...props })=>{
        // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(NewComponent, {
            size: size || 'medium',
            ...props
        });
    };
};
module.exports["createFeatureFlaggedComponent"] = $8993de4d80c5f842$export$e30d2ddc605f6bb;

});

parcelRegister("8UJqr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $2JKQ0 = parcelRequire("2JKQ0");


var $ihy5X = parcelRequire("ihy5X");


var $kejsE = parcelRequire("kejsE");

const $90de72697e043c02$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $90de72697e043c02$export$68f3db7f6af48bcb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Confluence" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $90de72697e043c02$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            svg: t5,
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        svg: $90de72697e043c02$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};
module.exports["ConfluenceIcon"] = $90de72697e043c02$export$68f3db7f6af48bcb;

});

parcelRegister("bltJZ", function(module, exports) {
$parcel$export(module.exports, "AtlasIcon", () => (parcelRequire("iXV0W")).AtlasIcon);
$parcel$export(module.exports, "AtlasLogo", () => (parcelRequire("lNhWn")).AtlasLogo);
$parcel$export(module.exports, "AtlassianMarketplaceIcon", () => (parcelRequire("3FmCf")).AtlassianMarketplaceIcon);
$parcel$export(module.exports, "AtlassianMarketplaceLogo", () => (parcelRequire("2CnS6")).AtlassianMarketplaceLogo);
$parcel$export(module.exports, "AtlassianAccessIcon", () => (parcelRequire("h47pR")).AtlassianAccessIcon);
$parcel$export(module.exports, "AtlassianAccessLogo", () => (parcelRequire("6aKgW")).AtlassianAccessLogo);
$parcel$export(module.exports, "JiraWorkManagementLogo", () => (parcelRequire("dnlpr")).JiraWorkManagementLogo);
$parcel$export(module.exports, "JiraWorkManagementIcon", () => (parcelRequire("9opDp")).JiraWorkManagementIcon);
$parcel$export(module.exports, "AtlassianIcon", () => (parcelRequire("NlHoa")).AtlassianIcon);
$parcel$export(module.exports, "AtlassianLogo", () => (parcelRequire("kbI17")).AtlassianLogo);
$parcel$export(module.exports, "JiraSoftwareIcon", () => (parcelRequire("llfZq")).JiraSoftwareIcon);
$parcel$export(module.exports, "JiraSoftwareLogo", () => (parcelRequire("cwhx1")).JiraSoftwareLogo);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $03276b3d04b76dd1$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25" clip-rule="evenodd"/>
</svg>
`;
const $03276b3d04b76dd1$export$ef8e5f836dd989d3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AdminIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Admin" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $03276b3d04b76dd1$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function AdminIcon({ size: size, appearance: appearance = 'brand', label: label = 'Admin', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $03276b3d04b76dd1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};





















var $hekY6 = parcelRequire("hekY6");


var $ixfCV = parcelRequire("ixfCV");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $6cf4ce054ddb9b6b$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
}; // These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
const $6cf4ce054ddb9b6b$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
const $6cf4ce054ddb9b6b$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6cf4ce054ddb9b6b$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6cf4ce054ddb9b6b$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6cf4ce054ddb9b6b$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6cf4ce054ddb9b6b$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6cf4ce054ddb9b6b$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6cf4ce054ddb9b6b$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
const $6cf4ce054ddb9b6b$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
const $6cf4ce054ddb9b6b$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
const $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LogoWrapper(t0) {
    const $ = (0, $bDgLe.c)(21);
    const { appearance: t1, size: t2, svg: svg, customThemeSvg: customThemeSvg, label: label, testId: userDefinedTestId, iconColor: customIconColor, textColor: customTextColor, isAssets: t3, type: t4 } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const size = t2 === undefined ? "small" : t2;
    const isAssets = t3 === undefined ? false : t3;
    const type = t4 === undefined ? "tile" : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    const t5 = customIconColor === "inherit" ? customTextColor : customIconColor;
    const t6 = customTextColor || "inherit";
    let t7;
    if ($[0] !== t5 || $[1] !== t6) {
        t7 = {
            "--themed-icon-color": t5,
            "--themed-text-color": t6
        };
        $[0] = t5;
        $[1] = t6;
        $[2] = t7;
    } else t7 = $[2];
    const t8 = t7;
    const t9 = label ? label : undefined;
    const t10 = label ? "img" : undefined;
    const t11 = label === "" ? true : undefined;
    const t12 = isCustomThemed ? customThemeSvg : svg;
    let t13;
    if ($[3] !== t12) {
        t13 = {
            __html: t12
        };
        $[3] = t12;
        $[4] = t13;
    } else t13 = $[4];
    const t14 = $6cf4ce054ddb9b6b$var$logoTextColorMap[colorMode ?? "light"];
    const t15 = $6cf4ce054ddb9b6b$var$sizeMap[size];
    const t16 = colorMode === "dark" ? $6cf4ce054ddb9b6b$var$textDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$textLightAppearanceMap[appearance];
    const t17 = colorMode === "dark" ? $6cf4ce054ddb9b6b$var$dataCenterDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$dataCenterLightAppearanceMap[appearance];
    const t18 = type === "rovo" ? colorMode === "dark" ? $6cf4ce054ddb9b6b$var$rovoDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$rovoLightAppearanceMap[appearance] : colorMode === "dark" ? $6cf4ce054ddb9b6b$var$cloudDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$cloudLightAppearanceMap[appearance];
    let t19;
    if ($[5] !== appearance || $[6] !== isAssets || $[7] !== t14 || $[8] !== t15 || $[9] !== t16 || $[10] !== t17 || $[11] !== t18) {
        t19 = (0, $hekY6.default)([
            $6cf4ce054ddb9b6b$var$styles.root,
            t14,
            t15,
            t16,
            t17,
            t18,
            isAssets && appearance === "brand" && ((0, $ixfCV.fg)("assets-platform-branding") || (0, $ixfCV.fg)("assets-platform-branding-with-confluence")) && $6cf4ce054ddb9b6b$var$styles.TEMP_assets
        ]);
        $[5] = appearance;
        $[6] = isAssets;
        $[7] = t14;
        $[8] = t15;
        $[9] = t16;
        $[10] = t17;
        $[11] = t18;
        $[12] = t19;
    } else t19 = $[12];
    let t20;
    if ($[13] !== t10 || $[14] !== t11 || $[15] !== t13 || $[16] !== t19 || $[17] !== t8 || $[18] !== t9 || $[19] !== testId) {
        t20 = /*#__PURE__*/ $cozmU.createElement("span", {
            style: t8,
            "data-testid": testId,
            "aria-label": t9,
            role: t10,
            "aria-hidden": t11,
            dangerouslySetInnerHTML: t13,
            className: t19
        });
        $[13] = t10;
        $[14] = t11;
        $[15] = t13;
        $[16] = t19;
        $[17] = t8;
        $[18] = t9;
        $[19] = testId;
        $[20] = t20;
    } else t20 = $[20];
    return t20;
} : function LogoWrapper({ appearance: appearance = 'brand', size: size = 'small', svg: svg, customThemeSvg: customThemeSvg, label: label, testId: userDefinedTestId, iconColor: customIconColor, textColor: customTextColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ $cozmU.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $hekY6.default)([
            $6cf4ce054ddb9b6b$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $6cf4ce054ddb9b6b$var$logoTextColorMap[colorMode ?? 'light'],
            $6cf4ce054ddb9b6b$var$sizeMap[size],
            colorMode === 'dark' ? $6cf4ce054ddb9b6b$var$textDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $6cf4ce054ddb9b6b$var$dataCenterDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $6cf4ce054ddb9b6b$var$rovoDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $6cf4ce054ddb9b6b$var$cloudDarkAppearanceMap[appearance] : $6cf4ce054ddb9b6b$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $ixfCV.fg)('assets-platform-branding') || (0, $ixfCV.fg)('assets-platform-branding-with-confluence')) && $6cf4ce054ddb9b6b$var$styles.TEMP_assets
        ])
    });
};


// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $b9ab5b9d03a978e6$var$svg = `<svg height="100%" viewBox="0 0 126 32">
    <path fill="var(--text-color, #1e1f21)" d="M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179" clip-rule="evenodd"/>
</svg>
`;
const $b9ab5b9d03a978e6$export$61afcb38c001e19 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AdminLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Admin" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $b9ab5b9d03a978e6$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function AdminLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Admin', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $b9ab5b9d03a978e6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $1e1cc794ed57e6b4$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z"/>
</svg>
`;
const $1e1cc794ed57e6b4$export$70a0c2f5862937b6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AlignIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Align" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $1e1cc794ed57e6b4$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function AlignIcon({ size: size, appearance: appearance = 'brand', label: label = 'Align', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $1e1cc794ed57e6b4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $709af12c753ebbf9$var$svg = `<svg height="100%" viewBox="0 0 106 32">
    <path fill="var(--text-color, #1e1f21)" d="M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z"/>
</svg>
`;
const $709af12c753ebbf9$export$8b5103382c06639c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AlignLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Align" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $709af12c753ebbf9$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function AlignLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Align', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $709af12c753ebbf9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $13419d6b173b736d$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z"/>
</svg>
`;
const $13419d6b173b736d$export$af3460f51ce3602a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AnalyticsIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Analytics" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $13419d6b173b736d$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function AnalyticsIcon({ size: size, appearance: appearance = 'brand', label: label = 'Analytics', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $13419d6b173b736d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $d5eb558efb1e3f94$var$svg = `<svg height="100%" viewBox="0 0 161 32">
    <path fill="var(--text-color, #1e1f21)" d="M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z"/>
</svg>
`;
const $d5eb558efb1e3f94$export$f0bac2b7ac3e3504 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AnalyticsLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Analytics" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $d5eb558efb1e3f94$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function AnalyticsLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Analytics', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $d5eb558efb1e3f94$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $83056c684d55bb4d$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"/>
</svg>
`;
const $83056c684d55bb4d$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729"/>
</svg>
`;
const $83056c684d55bb4d$export$d89497e7f33ca6f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AssetsIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Assets" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $83056c684d55bb4d$var$svg,
            customThemeSvg: $83056c684d55bb4d$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            isAssets: true,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function AssetsIcon({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Assets', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $83056c684d55bb4d$var$svg,
        customThemeSvg: $83056c684d55bb4d$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $025c567fc54454f6$var$svg = `<svg height="100%" viewBox="0 0 126 32">
    <path fill="var(--text-color, #1e1f21)" d="M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z"/>
</svg>
`;
const $025c567fc54454f6$export$81c47abe19675c4c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AssetsLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Assets" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $025c567fc54454f6$var$svg,
            label: label,
            isAssets: true,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function AssetsLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Assets', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $025c567fc54454f6$var$svg,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $e6d7a17105c18a62$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z"/>
</svg>
`;
const $e6d7a17105c18a62$export$e812398311cab9a3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BambooIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Bamboo" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $e6d7a17105c18a62$var$svg,
            label: label,
            type: "data-center",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function BambooIcon({ size: size, appearance: appearance = 'brand', label: label = 'Bamboo', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $e6d7a17105c18a62$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $7713916fd1b85a1e$var$svg = `<svg height="100%" viewBox="0 0 154 32">
    <path fill="var(--text-color, #1e1f21)" d="M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z"/>
</svg>
`;
const $7713916fd1b85a1e$export$7c51958462d750e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BambooLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Bamboo" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $7713916fd1b85a1e$var$svg,
            label: label,
            type: "data-center",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function BambooLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Bamboo', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $7713916fd1b85a1e$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $aba0f5cd4314443d$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578"/>
</svg>
`;
const $aba0f5cd4314443d$export$d3ab16bbf4f954ee = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BitbucketDataCenterIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Bitbucket Data Center" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $aba0f5cd4314443d$var$svg,
            label: label,
            type: "data-center",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function BitbucketDataCenterIcon({ size: size, appearance: appearance = 'brand', label: label = 'Bitbucket Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $aba0f5cd4314443d$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $bff633c1c17e420e$var$svg = `<svg height="100%" viewBox="0 0 166 32">
    <path fill="var(--text-color, #1e1f21)" d="M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771"/>
</svg>
`;
const $bff633c1c17e420e$export$cc55e2a4c4b40552 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BitbucketDataCenterLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Bitbucket Data Center" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $bff633c1c17e420e$var$svg,
            label: label,
            type: "data-center",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function BitbucketDataCenterLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Bitbucket Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $bff633c1c17e420e$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $d28d5aedb34440f3$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582"/>
</svg>
`;
const $d28d5aedb34440f3$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z"/>
</svg>
`;
const $d28d5aedb34440f3$export$5fc1066e677788d4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BitbucketIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Bitbucket" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $d28d5aedb34440f3$var$svg,
            customThemeSvg: $d28d5aedb34440f3$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function BitbucketIcon({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Bitbucket', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $d28d5aedb34440f3$var$svg,
        customThemeSvg: $d28d5aedb34440f3$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $96587aa986e6fd29$var$svg = `<svg height="100%" viewBox="0 0 166 32">
    <path fill="var(--text-color, #1e1f21)" d="M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z"/>
    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771"/>
</svg>
`;
const $96587aa986e6fd29$export$f7ef5e5488e4b430 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BitbucketLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Bitbucket" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $96587aa986e6fd29$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function BitbucketLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Bitbucket', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $96587aa986e6fd29$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $bbc4e0366bfee3cc$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z" clip-rule="evenodd"/>
</svg>
`;
const $bbc4e0366bfee3cc$export$52cd484a7ef4f2b9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChatIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Chat" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $bbc4e0366bfee3cc$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function ChatIcon({ size: size, appearance: appearance = 'brand', label: label = 'Chat', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $bbc4e0366bfee3cc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $4941f3d709f353e7$var$svg = `<svg height="100%" viewBox="0 0 102 32">
    <path fill="var(--text-color, #1e1f21)" d="M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.95c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M24.75 22.25H13.5L7.25 26V7.25h17.5zm-9.107-12.5-.34.864c-.482 1.226-.724 1.84-1.17 2.302s-1.05.725-2.258 1.251l-.518.226v.714l.518.226c1.209.526 1.813.79 2.259 1.251.445.462.687 1.076 1.17 2.303l.34.863h.714l.34-.864c.482-1.227.724-1.84 1.17-2.302s1.049-.725 2.258-1.251l.517-.226v-.714l-.517-.226c-1.21-.526-1.813-.79-2.259-1.251-.445-.462-.687-1.075-1.17-2.302l-.34-.864z" clip-rule="evenodd"/>
</svg>
`;
const $4941f3d709f353e7$export$a529e78951cd6709 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChatLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Chat" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $4941f3d709f353e7$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function ChatLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Chat', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $4941f3d709f353e7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $c5c763fd1c1f1441$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M6.75 19V5h10.5v14h-3.937v-3.062h-2.625V19zM9.375 8.063h1.75V6.75h-1.75zm3.5 0h1.75V6.75h-1.75zm-1.75 3.062h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75zm5.25-3.063h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75z" clip-rule="evenodd"/>
</svg>
`;
const $c5c763fd1c1f1441$export$5ef3f25e16249826 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CompanyHubIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Company Hub" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $c5c763fd1c1f1441$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function CompanyHubIcon({ size: size, appearance: appearance = 'brand', label: label = 'Company Hub', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $c5c763fd1c1f1441$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $257113bac26a9036$var$svg = `<svg height="100%" viewBox="0 0 129 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M6.75 19V5h10.5v14h-3.937v-3.062h-2.625V19zM9.375 8.063h1.75V6.75h-1.75zm3.5 0h1.75V6.75h-1.75zm-1.75 3.062h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75zm5.25-3.063h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75z" clip-rule="evenodd"/>
    <path fill="var(--text-color, #292a2e)" d="M124.53 17.13q-.64 0-1.07-.21a2.3 2.3 0 0 1-.7-.53 3 3 0 0 1-.4-.61h-.1V17h-1.89V6.81h1.93v3.82h.07a3 3 0 0 1 .4-.61q.26-.32.69-.54t1.09-.22q.87 0 1.57.44.71.44 1.13 1.32.42.87.42 2.17 0 1.26-.41 2.15-.41.87-1.12 1.33a2.87 2.87 0 0 1-1.6.46m-.56-1.55q.57 0 .95-.31a1.9 1.9 0 0 0 .57-.85q.2-.54.2-1.23t-.2-1.22a1.8 1.8 0 0 0-.57-.83q-.38-.31-.95-.31-.55 0-.94.29-.38.29-.58.83-.2.53-.2 1.24t.2 1.25q.21.54.59.84.39.3.94.3m-9.65 1.52q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V9.37h1.93v4.54q0 .75.38 1.16t1.05.42q.46 0 .81-.19a1.4 1.4 0 0 0 .55-.57q.2-.38.2-.9V9.38h1.93V17h-1.82l-.02-1.9h.12q-.31.98-.93 1.49t-1.56.51m-13.01-.1V6.81h1.96v4.16h4.58V6.81h1.97V17h-1.97v-4.39h-4.58V17zm-11.89 2.71.45-1.47.23.06q.41.11.73.06a.83.83 0 0 0 .52-.27q.2-.22.27-.62l.08-.44-2.88-7.67h2.04l1.34 4.05q.24.75.39 1.49.16.75.34 1.54h-.47l.37-1.54q.18-.75.43-1.49l1.4-4.05h2.02l-3.26 8.58q-.23.62-.59 1.06-.35.44-.88.68-.52.24-1.25.24-.4 0-.74-.06a2.5 2.5 0 0 1-.53-.14m-6.44-7.17V17h-1.93V9.36h1.82l.04 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.59.34.92.98t.33 1.55V17H86v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.34 1.34 0 0 0-.55.57q-.2.37-.2.9m-7.92 4.58a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.13-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M63.5 19.86V9.36h1.89v1.28h.1q.14-.29.4-.61t.69-.54 1.09-.22q.87 0 1.57.44.71.44 1.13 1.32.42.87.42 2.17 0 1.26-.41 2.15-.41.87-1.12 1.33a2.87 2.87 0 0 1-1.6.46q-.64 0-1.07-.21a2.3 2.3 0 0 1-.7-.53 3 3 0 0 1-.4-.61h-.07v4.07zm3.61-4.28q.57 0 .95-.31t.57-.85q.2-.54.2-1.23t-.2-1.22a1.8 1.8 0 0 0-.57-.83q-.38-.31-.95-.31-.56 0-.94.29t-.58.83q-.2.53-.2 1.24t.2 1.25q.21.54.59.84.39.3.94.3M50.8 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3.56.3.87.88.32.58.32 1.42V17h-1.92v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.89-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34-.37 0-.68.17a1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-5.18.15q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.97-.49 1.96.49q.83.49 1.29 1.39.45.89.45 2.07t-.45 2.07-1.29 1.38q-.83.49-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23 1.87 1.87 0 0 0-.58-.86q-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31m-9.25 1.51q-1.35 0-2.41-.62t-1.67-1.79-.61-2.82.62-2.82q.62-1.18 1.68-1.79 1.07-.62 2.4-.62.85 0 1.59.24.75.24 1.32.7t.94 1.12.49 1.51h-1.98a2.2 2.2 0 0 0-.28-.77 2 2 0 0 0-.51-.57q-.3-.24-.69-.36a2.8 2.8 0 0 0-.83-.12q-.81 0-1.43.41-.62.4-.97 1.18-.34.78-.34 1.89 0 1.13.35 1.91.35.77.96 1.17a2.6 2.6 0 0 0 1.43.4q.45 0 .83-.12.39-.12.7-.36.32-.24.52-.57.21-.34.29-.77h1.98q-.09.72-.43 1.36a4.2 4.2 0 0 1-.9 1.15 4.2 4.2 0 0 1-1.32.79q-.76.28-1.69.28"/>
</svg>
`;
const $257113bac26a9036$export$1ab0976b9ea166ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CompanyHubLogo(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Company Hub" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $257113bac26a9036$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function CompanyHubLogo({ size: size, appearance: appearance = 'brand', label: label = 'Company Hub', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $257113bac26a9036$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $08074ca1ab8ce06c$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z"/>
</svg>
`;
const $08074ca1ab8ce06c$export$f7857fe64d7161d9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CompassIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Compass" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $08074ca1ab8ce06c$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function CompassIcon({ size: size, appearance: appearance = 'brand', label: label = 'Compass', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $08074ca1ab8ce06c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $a403e2ffb4d2e315$var$svg = `<svg height="100%" viewBox="0 0 162 32">
    <path fill="var(--text-color, #1e1f21)" d="M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z"/>
</svg>
`;
const $a403e2ffb4d2e315$export$a16f50a81d183ce = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CompassLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Compass" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $a403e2ffb4d2e315$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function CompassLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Compass', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $a403e2ffb4d2e315$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $2e5df0b036034f27$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617"/>
</svg>
`;
const $2e5df0b036034f27$export$53305f1f2855d3be = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ConfluenceDataCenterIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Confluence Data Center" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $2e5df0b036034f27$var$svg,
            label: label,
            type: "data-center",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function ConfluenceDataCenterIcon({ size: size, appearance: appearance = 'brand', label: label = 'Confluence Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $2e5df0b036034f27$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $66c39101e57479f4$var$svg = `<svg height="100%" viewBox="0 0 188 32">
    <path fill="var(--text-color, #1e1f21)" d="M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823"/>
</svg>
`;
const $66c39101e57479f4$export$b3e508cb103e1f93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ConfluenceDataCenterLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Confluence Data Center" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $66c39101e57479f4$var$svg,
            label: label,
            type: "data-center",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function ConfluenceDataCenterLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Confluence Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $66c39101e57479f4$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
};



var $5lkNm = parcelRequire("5lkNm");











// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $1c9a1ac3a4cee6e2$var$svg = `<svg height="100%" viewBox="0 0 188 32">
    <path fill="var(--text-color, #1e1f21)" d="M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823"/>
</svg>
`;
const $1c9a1ac3a4cee6e2$export$a88b0b0da9ef63ce = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ConfluenceLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Confluence" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $1c9a1ac3a4cee6e2$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function ConfluenceLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Confluence', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $1c9a1ac3a4cee6e2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $f6cd25d2c8e75fff$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433"/>
</svg>
`;
const $f6cd25d2c8e75fff$export$eaf73f391f7103bd = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CrowdIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Crowd" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $f6cd25d2c8e75fff$var$svg,
            label: label,
            type: "data-center",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function CrowdIcon({ size: size, appearance: appearance = 'brand', label: label = 'Crowd', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $f6cd25d2c8e75fff$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $eaf1114a279cc25b$var$svg = `<svg height="100%" viewBox="0 0 126 32">
    <path fill="var(--text-color, #1e1f21)" d="M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577"/>
</svg>
`;
const $eaf1114a279cc25b$export$3c371bdbcdfcdce = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CrowdLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Crowd" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $eaf1114a279cc25b$var$svg,
            label: label,
            type: "data-center",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function CrowdLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Crowd', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $eaf1114a279cc25b$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $9a9c3f6859fd2ed7$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M19 12a7 7 0 1 0-14 0 7 7 0 0 0 14 0m-9.37 4.625.026.074a5.26 5.26 0 0 1-2.833-3.824h2.136c.069 1.426.306 2.73.67 3.75m1.08-3.75c.068 1.255.278 2.353.567 3.162.179.5.37.841.54 1.042a.6.6 0 0 0 .183.165.7.7 0 0 0 .183-.165c.17-.2.361-.543.54-1.042.288-.809.498-1.907.566-3.162zm2.58-1.75h-2.58c.068-1.255.278-2.353.567-3.162.179-.5.37-.841.54-1.042A.7.7 0 0 1 12 6.756a.6.6 0 0 1 .183.165c.17.2.361.543.54 1.042.288.809.498 1.907.566 3.162m1.751 1.75c-.069 1.426-.306 2.73-.67 3.75l-.027.074a5.26 5.26 0 0 0 2.833-3.824zm2.136-1.75H15.04c-.069-1.426-.306-2.73-.67-3.75l-.027-.074a5.26 5.26 0 0 1 2.833 3.824m-8.218 0H6.823a5.26 5.26 0 0 1 2.833-3.824l-.027.074c-.364 1.02-.601 2.324-.67 3.75" clip-rule="evenodd"/>
</svg>
`;
const $9a9c3f6859fd2ed7$export$5efe8561ca252843 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CustomLinkIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Custom Link" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $9a9c3f6859fd2ed7$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function CustomLinkIcon({ size: size, appearance: appearance = 'brand', label: label = 'Custom Link', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $9a9c3f6859fd2ed7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $4f22854d02c31273$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z"/>
</svg>
`;
const $4f22854d02c31273$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5"/>
</svg>
`;
const $4f22854d02c31273$export$6da5aa77c402ba0f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CustomerServiceManagementIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Customer Service Management" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $4f22854d02c31273$var$svg,
            customThemeSvg: $4f22854d02c31273$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function CustomerServiceManagementIcon({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Customer Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $4f22854d02c31273$var$svg,
        customThemeSvg: $4f22854d02c31273$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $90490e8b2c406928$var$svg = `<svg height="100%" viewBox="0 0 456 32">
    <path fill="var(--text-color, #1e1f21)" d="M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z"/>
</svg>
`;
const $90490e8b2c406928$export$f597f0f7fadce0b9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CustomerServiceManagementLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Customer Service Management" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $90490e8b2c406928$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function CustomerServiceManagementLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Customer Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $90490e8b2c406928$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $a72594f5636889fa$var$svg = `<svg height="100%" viewBox="0 0 48 48">
    <path fill="var(--tile-color,#94c748)" d="M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z"/>
    <path fill="var(--icon-color, #101214)" d="m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z"/>
</svg>
`;
const $a72594f5636889fa$export$9951d02c2d848122 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DxIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Dx" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $a72594f5636889fa$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function DxIcon({ size: size, appearance: appearance = 'brand', label: label = 'Dx', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $a72594f5636889fa$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $abe90306ef3e27a5$var$svg = `<svg height="100%" viewBox="0 0 48 48">
    <rect width="48" height="48" fill="var(--tile-color,#c97cf4)" rx="12"/>
    <path fill="var(--icon-color, #101214)" d="M20 19h5v11h-5zm7-9h5v28h-5zm7 6h5v16h-5zm-21 0h5v16h-5zm-7 5h5v7H6z"/>
</svg>
`;
const $abe90306ef3e27a5$export$34420f0520b19b1d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FeedbackIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Feedback" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $abe90306ef3e27a5$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function FeedbackIcon({ size: size, appearance: appearance = 'brand', label: label = 'Feedback', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $abe90306ef3e27a5$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $4c8210cc6f9fba72$var$svg = `<svg height="100%" viewBox="0 0 169 32">
    <path fill="var(--text-color, #1e1f21)" d="M157.894 25.334h-2.638V3.59h2.638v13.585L164.487 10h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.177zm-5.648-2.761v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.489s1.656 5.49 5.674 5.49c1.564 0 2.545-.215 3.496-.553m-26.118-4.906c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.638v15.333zm-16.09-7.666c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.502-4.478 4.906v1.227c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.698H107.4V3.592h2.637v9.17c.982-2.025 2.822-3.068 5.183-3.068 4.079 0 6.133 3.466 6.133 7.974 0 4.324-2.146 7.973-6.44 7.973m-22.806-7.974c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.963-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.08 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.013 4.876 3.006V3.59h2.638v21.743zM80.502 12.085c-2.79 0-4.201 1.81-4.477 4.478h8.555c-.153-2.852-1.44-4.478-4.078-4.478M86.39 24.72c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.625 3.282 6.625 7.943v1.196H76.055c.368 2.607 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zM64.42 12.085c-2.79 0-4.202 1.81-4.477 4.478h8.556c-.154-2.852-1.442-4.478-4.08-4.478m5.888 12.635c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.238-7.943 4.722 0 6.623 3.282 6.623 7.943v1.196H59.974c.368 2.607 2.055 4.293 5.674 4.293 1.778 0 3.28-.337 4.66-.828zm-15.679-6.9H45.49v7.514h-2.76V5.186h12.94v2.637H45.49v7.36h9.138z"/>
    <rect width="32" height="32" fill="var(--tile-color,#c97cf4)" rx="8"/>
    <path fill="var(--icon-color, #101214)" d="M13.333 12.667h3.334V20h-3.334zm4.667-6h3.333v18.666H18zm4.667 4H26v10.666h-3.333zm-14 0H12v10.666H8.667zM4 14h3.333v4.666H4z"/>
</svg>
`;
const $4c8210cc6f9fba72$export$bbccafb125ebd50c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FeedbackLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Feedback" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $4c8210cc6f9fba72$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function FeedbackLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Feedback', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $4c8210cc6f9fba72$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $b10ebbefbae983ec$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z"/>
</svg>
`;
const $b10ebbefbae983ec$export$1e02e7298035a77c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FocusIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Focus" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $b10ebbefbae983ec$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function FocusIcon({ size: size, appearance: appearance = 'brand', label: label = 'Focus', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $b10ebbefbae983ec$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $348690b5beae7695$var$svg = `<svg height="100%" viewBox="0 0 117 32">
    <path fill="var(--text-color, #1e1f21)" d="M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z"/>
    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z"/>
</svg>
`;
const $348690b5beae7695$export$3a6e8b37e069a69d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FocusLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Focus" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $348690b5beae7695$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function FocusLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Focus', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $348690b5beae7695$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $ad20b5467f7f9ada$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0" clip-rule="evenodd"/>
</svg>
`;
const $ad20b5467f7f9ada$export$9eb74917ea768ed4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GoalsIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Goals" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $ad20b5467f7f9ada$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function GoalsIcon({ size: size, appearance: appearance = 'brand', label: label = 'Goals', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $ad20b5467f7f9ada$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $ce22f23b1949f489$var$svg = `<svg height="100%" viewBox="0 0 116 32">
    <path fill="var(--text-color, #1e1f21)" d="M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0" clip-rule="evenodd"/>
</svg>
`;
const $ce22f23b1949f489$export$c527a545aa426db3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GoalsLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Goals" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $ce22f23b1949f489$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function GoalsLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Goals', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $ce22f23b1949f489$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $e71fdb92b5ae56b0$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649"/>
</svg>
`;
const $e71fdb92b5ae56b0$export$e26e48d31d71c1e1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GuardDetectIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Guard Detect" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $e71fdb92b5ae56b0$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function GuardDetectIcon({ size: size, appearance: appearance = 'brand', label: label = 'Guard Detect', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $e71fdb92b5ae56b0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $1ea751a953e0497b$var$svg = `<svg height="100%" viewBox="0 0 121 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649"/>
    <path fill="var(--text-color, #292a2e)" d="M120.03 9.36v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19a3 3 0 0 0 .32-.03 5 5 0 0 0 .32-.06l.29 1.46a3.4 3.4 0 0 1-.63.13 5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-5.13 9.61q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86q.39.31.97.31.32 0 .57-.09.26-.09.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06t-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-8.29-.02q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.54 1.54 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-4.67-7.8v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03.21-.03.32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-5.19 9.61q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06A3.4 3.4 0 0 1 88 9.77q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31a1.4 1.4 0 0 0 .34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25M80.08 17h-2.6v-1.69H80q1.02 0 1.71-.37t1.03-1.12q.35-.76.35-1.91t-.35-1.9a2.32 2.32 0 0 0-1.02-1.12q-.68-.37-1.69-.37h-2.61v-1.7h2.71q1.52 0 2.62.61a4.1 4.1 0 0 1 1.69 1.75q.6 1.14.6 2.73t-.59 2.74a4.1 4.1 0 0 1-1.7 1.76q-1.12.59-2.67.59M78.53 6.81V17h-1.96V6.81zM67.1 17.13a2.9 2.9 0 0 1-1.6-.46q-.71-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.13-1.32a2.9 2.9 0 0 1 1.57-.44q.66 0 1.09.23.43.22.69.54.27.32.4.61h.07V6.81h1.92V17h-1.89v-1.22h-.1a2.8 2.8 0 0 1-.4.61q-.27.31-.7.53-.43.21-1.07.21m.56-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.59-.83q-.38-.29-.94-.29-.57 0-.95.31a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.22q0 .69.19 1.23.2.54.58.85.39.31.95.31M58.98 17V9.36h1.87v1.31h.08q.2-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-5.98.13a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.56 0 .94-.3t.58-.84q.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31m-9.43 1.53q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V9.37h1.93v4.54q0 .75.38 1.16t1.05.42q.46 0 .81-.19.35-.2.55-.57t.2-.9V9.38h1.93V17h-1.82l-.02-1.9h.12q-.31.98-.93 1.49t-1.56.51m-8.95.04q-1.29 0-2.32-.64-1.02-.63-1.63-1.8-.6-1.17-.6-2.77 0-1.65.62-2.82t1.68-1.8q1.07-.63 2.41-.63.85 0 1.58.25.74.25 1.31.7.57.46.94 1.09a3.8 3.8 0 0 1 .49 1.37h-2.01a2.3 2.3 0 0 0-.32-.69 2 2 0 0 0-.5-.52 2 2 0 0 0-.66-.33 2.6 2.6 0 0 0-.81-.12q-.81 0-1.43.4T33 10.01q-.35.77-.35 1.89 0 1.11.35 1.89t.98 1.19q.64.4 1.48.4.76 0 1.3-.29a2 2 0 0 0 .83-.83q.29-.55.29-1.29h.42v.85q0 .66-.16 1.26t-.53 1.06q-.35.47-.95.73-.59.27-1.45.27m3.24-.14-.26-2.43v-1.43H35.6v-1.52h4.19V17z"/>
</svg>
`;
const $1ea751a953e0497b$export$bf5ca9fb70f56bb5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GuardDetectLogo(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Guard Detect" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $1ea751a953e0497b$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function GuardDetectLogo({ size: size, appearance: appearance = 'brand', label: label = 'Guard Detect', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $1ea751a953e0497b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $29e11ce05e624c9c$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649"/>
</svg>
`;
const $29e11ce05e624c9c$export$3f95fcfdc25a741d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GuardIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Guard" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $29e11ce05e624c9c$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function GuardIcon({ size: size, appearance: appearance = 'brand', label: label = 'Guard', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $29e11ce05e624c9c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $a715ce8ba7389c6a$var$svg = `<svg height="100%" viewBox="0 0 120 32">
    <path fill="var(--text-color, #1e1f21)" d="M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778"/>
</svg>
`;
const $a715ce8ba7389c6a$export$2b896c4d595a4331 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GuardLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Guard" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $a715ce8ba7389c6a$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function GuardLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Guard', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $a715ce8ba7389c6a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $9255a8fd6323cfc1$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z"/>
</svg>
`;
const $9255a8fd6323cfc1$export$92c8767b874048d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function HomeIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Home" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $9255a8fd6323cfc1$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function HomeIcon({ size: size, appearance: appearance = 'brand', label: label = 'Home', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $9255a8fd6323cfc1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $bef638fba914ccdd$var$svg = `<svg height="100%" viewBox="0 0 121 32">
    <path fill="var(--text-color, #1e1f21)" d="M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z"/>
</svg>
`;
const $bef638fba914ccdd$export$8b6b7f1b1b2367d3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function HomeLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Home" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $bef638fba914ccdd$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function HomeLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Home', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $bef638fba914ccdd$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $841a22a6d07f9832$var$svg = `<svg height="100%" viewBox="0 0 32 32">
    <g clip-path="url(#clip0_95164_16219)">
        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g clip-path="url(#clip1_95164_16219)">
            <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z" clip-rule="evenodd"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_16219">
            <path fill="var(--icon-color, white)" d="M0 0h32v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_16219">
            <path fill="var(--icon-color, white)" d="M2 2h28v28H2z"/>
        </clipPath>
    </defs>
</svg>
`;
const $841a22a6d07f9832$export$80b8b269d8b5014e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function HubIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Hub" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $841a22a6d07f9832$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function HubIcon({ size: size, appearance: appearance = 'brand', label: label = 'Hub', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $841a22a6d07f9832$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $13f5db28dc876d37$var$svg = `<svg height="100%" viewBox="0 0 95 32">
    <path fill="var(--text-color, #1e1f21)" d="M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z" clip-rule="evenodd"/>
</svg>
`;
const $13f5db28dc876d37$export$7a38180641471460 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function HubLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Hub" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $13f5db28dc876d37$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function HubLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Hub', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $13f5db28dc876d37$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $be05cd4e46cc9418$var$svg = `<svg height="100%" viewBox="0 0 55 55">
    <path fill="var(--tile-color,#1868db)" d="M24.519.844a6.3 6.3 0 0 1 6.3 0l18.37 10.601a6.3 6.3 0 0 1 3.15 5.454V38.1c0 2.25-1.2 4.33-3.15 5.454l-18.37 10.601a6.3 6.3 0 0 1-6.3 0l-18.37-10.6a6.3 6.3 0 0 1-3.15-5.454V16.9c0-2.25 1.2-4.33 3.15-5.454z"/>
    <path fill="var(--icon-color, white)" d="M20.71 34.657h-2.705C13.926 34.657 11 32.16 11 28.5h14.543c.754 0 1.241.536 1.241 1.294v14.634c-3.635 0-6.074-2.944-6.074-7.05zm7.183-7.272h-2.705c-4.079 0-7.005-2.454-7.005-6.113h14.542c.754 0 1.286.491 1.286 1.25v14.634c-3.635 0-6.118-2.945-6.118-7.05zm7.227-7.228h-2.705c-4.079 0-7.005-2.498-7.005-6.157h14.543c.753 0 1.241.535 1.241 1.25v14.633c-3.636 0-6.074-2.944-6.074-7.049z"/>
</svg>
`;
const $be05cd4e46cc9418$export$b12fec207e8537a8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function JiraCodingAgentIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Jira Coding Agent" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $be05cd4e46cc9418$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function JiraCodingAgentIcon({ size: size, appearance: appearance = 'brand', label: label = 'Jira Coding Agent', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $be05cd4e46cc9418$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $19e672ea9865e4df$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z"/>
</svg>
`;
const $19e672ea9865e4df$export$f8455b5667a3ee0c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function JiraDataCenterIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Jira Data Center" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $19e672ea9865e4df$var$svg,
            label: label,
            type: "data-center",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function JiraDataCenterIcon({ size: size, appearance: appearance = 'brand', label: label = 'Jira Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $19e672ea9865e4df$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $2830ebef819e6a54$var$svg = `<svg height="100%" viewBox="0 0 83 32">
    <path fill="var(--text-color, #1e1f21)" d="M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z"/>
</svg>
`;
const $2830ebef819e6a54$export$3224b07bc93ef23e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function JiraDataCenterLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Jira Data Center" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $2830ebef819e6a54$var$svg,
            label: label,
            type: "data-center",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function JiraDataCenterLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Jira Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $2830ebef819e6a54$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $9f7a3b7caba550ed$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z"/>
</svg>
`;
const $9f7a3b7caba550ed$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228"/>
</svg>
`;
const $9f7a3b7caba550ed$export$21bfbeb62fdcce8d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function JiraProductDiscoveryIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Jira Product Discovery" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $9f7a3b7caba550ed$var$svg,
            customThemeSvg: $9f7a3b7caba550ed$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function JiraProductDiscoveryIcon({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Jira Product Discovery', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $9f7a3b7caba550ed$var$svg,
        customThemeSvg: $9f7a3b7caba550ed$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $43cf7dd3eda107a4$var$svg = `<svg height="100%" viewBox="0 0 327 32">
    <path fill="var(--text-color, #1e1f21)" d="M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#c97cf4)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z"/>
</svg>
`;
const $43cf7dd3eda107a4$export$602140a6a10b02bf = (0, $gtMdU.isReactCompilerActivePlatform)() ? function JiraProductDiscoveryLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Jira Product Discovery" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $43cf7dd3eda107a4$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function JiraProductDiscoveryLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Jira Product Discovery', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $43cf7dd3eda107a4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $712f916716e5e7e0$var$svg = `<svg height="100%" viewBox="0 0 25 24">
    <path fill="var(--tile-color, white)" d="M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z"/>
</svg>
`;
const $712f916716e5e7e0$export$65fae0eaf343f2ca = (0, $gtMdU.isReactCompilerActivePlatform)() ? function JiraServiceManagementDataCenterIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Jira Service Management Data Center" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $712f916716e5e7e0$var$svg,
            label: label,
            type: "data-center",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function JiraServiceManagementDataCenterIcon({ size: size, appearance: appearance = 'brand', label: label = 'Jira Service Management Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $712f916716e5e7e0$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $7cc171059637a3ab$var$svg = `<svg height="100%" viewBox="0 0 372 32">
    <path fill="var(--text-color, #1e1f21)" d="M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z"/>
</svg>
`;
const $7cc171059637a3ab$export$f64bc7a7f04428d0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function JiraServiceManagementDataCenterLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Jira Service Management Data Center" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $7cc171059637a3ab$var$svg,
            label: label,
            type: "data-center",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function JiraServiceManagementDataCenterLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Jira Service Management Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $7cc171059637a3ab$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $9d7fd522dc0dc942$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z"/>
</svg>
`;
const $9d7fd522dc0dc942$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z"/>
</svg>
`;
const $9d7fd522dc0dc942$export$3c6158790f5e01c4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function JiraServiceManagementIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Jira Service Management" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $9d7fd522dc0dc942$var$svg,
            customThemeSvg: $9d7fd522dc0dc942$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function JiraServiceManagementIcon({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Jira Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $9d7fd522dc0dc942$var$svg,
        customThemeSvg: $9d7fd522dc0dc942$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $861d2782289acd74$var$svg = `<svg height="100%" viewBox="0 0 372 32">
    <path fill="var(--text-color, #1e1f21)" d="M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z"/>
</svg>
`;
const $861d2782289acd74$export$de148263c75d2bc1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function JiraServiceManagementLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Jira Service Management" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $861d2782289acd74$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function JiraServiceManagementLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Jira Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $861d2782289acd74$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};



var $ldJ1U = parcelRequire("ldJ1U");











// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $b1390b168e69241b$var$svg = `<svg height="100%" viewBox="0 0 83 32">
    <path fill="var(--text-color, #1e1f21)" d="M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z"/>
</svg>
`;
const $b1390b168e69241b$export$bf4c5f97b468e8d6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function JiraLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Jira" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $b1390b168e69241b$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function JiraLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Jira', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $b1390b168e69241b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $3550bc2b37be7afe$var$svg = `<svg height="100%" viewBox="0 0 100 32">
    <path fill="var(--icon-color, #101214)" d="M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593"/>
    <path fill="var(--text-color, #1e1f21)" d="M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68"/>
</svg>
`;
const $3550bc2b37be7afe$export$68d7391318cdef11 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoomAttributionLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Loom Attribution" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $3550bc2b37be7afe$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function LoomAttributionLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Loom Attribution', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $3550bc2b37be7afe$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $b6ba3ab0a68971c2$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#625df5)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
const $b6ba3ab0a68971c2$export$38c7b37a3e5e8d70 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoomInternalIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Loom" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $b6ba3ab0a68971c2$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function LoomInternalIcon({ size: size, appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $b6ba3ab0a68971c2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $fc522095f7179715$var$svg = `<svg height="100%" viewBox="0 0 103 32">
    <path fill="var(--tile-color,#625df5)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593"/>
    <path fill="var(--text-color, #1e1f21)" d="M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19"/>
</svg>
`;
const $fc522095f7179715$export$71743a944cb62e48 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoomInternalLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Loom" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $fc522095f7179715$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function LoomInternalLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $fc522095f7179715$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};



var $lb2PL = parcelRequire("lb2PL");











// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $b618dd54a2366839$var$svg = `<svg height="100%" viewBox="0 0 103 32">
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593"/>
    <path fill="var(--text-color, #1e1f21)" d="M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19"/>
</svg>
`;
const $b618dd54a2366839$export$78c0b4d8be34c9b2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoomLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Loom" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $b618dd54a2366839$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function LoomLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $b618dd54a2366839$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $47ebd555be52a232$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M11.13 5.88H5.88v5.25h5.25zm0 7H5.88v5.25h5.25zm1.75-7h5.25v5.25h-5.25zm5.25 7h-5.25v5.25h5.25z"/>
</svg>
`;
const $47ebd555be52a232$export$518f48548316ec87 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MoreAtlassianAppsIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "More Atlassian Apps" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $47ebd555be52a232$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function MoreAtlassianAppsIcon({ size: size, appearance: appearance = 'brand', label: label = 'More Atlassian Apps', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $47ebd555be52a232$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $87e20010b263a529$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848"/>
</svg>
`;
const $87e20010b263a529$export$eeccc49dc7a12d9f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function OpsgenieIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Opsgenie" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $87e20010b263a529$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function OpsgenieIcon({ size: size, appearance: appearance = 'brand', label: label = 'Opsgenie', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $87e20010b263a529$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $844f6e2073bb4d67$var$svg = `<svg height="100%" viewBox="0 0 164 32">
    <path fill="var(--text-color, #1e1f21)" d="M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001"/>
</svg>
`;
const $844f6e2073bb4d67$export$a5b9122e89b32ad3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function OpsgenieLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Opsgenie" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $844f6e2073bb4d67$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function OpsgenieLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Opsgenie', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $844f6e2073bb4d67$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $87b9bf478c0c1673$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546" clip-rule="evenodd"/>
</svg>
`;
const $87b9bf478c0c1673$export$5ed3e1bb3b04fc02 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProjectsIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Projects" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $87b9bf478c0c1673$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function ProjectsIcon({ size: size, appearance: appearance = 'brand', label: label = 'Projects', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $87b9bf478c0c1673$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $702f9f52344cd4d9$var$svg = `<svg height="100%" viewBox="0 0 145 32">
    <path fill="var(--text-color, #1e1f21)" d="M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21" clip-rule="evenodd"/>
</svg>
`;
const $702f9f52344cd4d9$export$e3d1678155aaab99 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProjectsLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Projects" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $702f9f52344cd4d9$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function ProjectsLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Projects', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $702f9f52344cd4d9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $1eb0ba52efd1ec9a$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z" clip-rule="evenodd"/>
</svg>
`;
const $1eb0ba52efd1ec9a$export$813cff80931d9dbf = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoDevAgentIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Rovo Dev Agent" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $1eb0ba52efd1ec9a$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function RovoDevAgentIcon({ size: size, appearance: appearance = 'brand', label: label = 'Rovo Dev Agent', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $1eb0ba52efd1ec9a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $204c4a4a1c49503e$var$svg = `<svg height="100%" viewBox="0 0 160 32">
    <path fill="var(--text-color, #1e1f21)" d="M153.94 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zM136.3 12.42c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-25.13-16.9h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.52h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.25.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M45 8.16h-4.05v7.36H45c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--tile-color,#94c748)" d="M12.52.49a3.67 3.67 0 0 1 3.666 0l10.688 6.17a3.66 3.66 0 0 1 1.833 3.173v12.336a3.66 3.66 0 0 1-1.833 3.173L16.186 31.51a3.67 3.67 0 0 1-3.665 0L1.833 25.341A3.66 3.66 0 0 1 0 22.168V9.832c0-1.309.7-2.519 1.833-3.173z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m11.83 8.128-4.54 2.62a2.04 2.04 0 0 0-1.022 1.77v6.972c0 .728.39 1.405 1.023 1.77l1.076.62 4.963 2.865a2.05 2.05 0 0 0 2.01.02l.037-.025c.445-.257.771-.67.925-1.146q.094-.297.095-.619v-2.7l-2.627-1.516-.757-.436a2.67 2.67 0 0 1-1.34-2.32v-6.97a2.7 2.7 0 0 1 .157-.904" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M15.377 7.255a2.05 2.05 0 0 0-2.01-.019l-.038.026c-.445.257-.77.67-.924 1.145a2 2 0 0 0-.095.618v2.7l2.545 1.47.839.483a2.67 2.67 0 0 1 1.34 2.319v6.972a2.7 2.7 0 0 1-.157.903l4.54-2.62a2.04 2.04 0 0 0 1.022-1.77v-6.971c0-.729-.39-1.405-1.023-1.77l-1.157-.668z" clip-rule="evenodd"/>
</svg>
`;
const $204c4a4a1c49503e$export$58747af448450872 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoDevAgentLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Rovo Dev Agent" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $204c4a4a1c49503e$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function RovoDevAgentLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Rovo Dev Agent', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $204c4a4a1c49503e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $50837398edad00a7$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z"/>
    <path fill="var(--icon-color, #101214)" d="M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75"/>
</svg>
`;
const $50837398edad00a7$export$8b784b3227531b3e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoDevIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Rovo Dev" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $50837398edad00a7$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function RovoDevIcon({ size: size, appearance: appearance = 'brand', label: label = 'Rovo Dev', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $50837398edad00a7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $fc2002c31bb68cd3$var$svg = `<svg height="100%" viewBox="0 0 165 32">
    <path fill="var(--text-color, #1e1f21)" d="M158.79 25.33h-3.53L149.32 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.64-13.24c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM121.91 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.26.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.86 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682a2.26 2.26 0 0 1 1.021-1.267h.002z"/>
    <path fill="var(--icon-color, #101214)" d="m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1"/>
</svg>
`;
const $fc2002c31bb68cd3$export$4145bd793c9ed1d0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoDevLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Rovo Dev" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $fc2002c31bb68cd3$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function RovoDevLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Rovo Dev', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $fc2002c31bb68cd3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $d73bd19527e99345$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
const $d73bd19527e99345$export$9e62346a60cfb459 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoHexIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Rovo" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $d73bd19527e99345$var$svg,
            label: label,
            type: "rovo",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function RovoHexIcon({ size: size, appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $d73bd19527e99345$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $23f94ca63efd0f1b$var$svg = `<svg height="100%" viewBox="0 0 102 32">
    <path fill="var(--text-color, #1e1f21)" d="M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z" clip-rule="evenodd"/>
</svg>
`;
const $23f94ca63efd0f1b$export$5e38d02efdb45577 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoHexLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Rovo" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $23f94ca63efd0f1b$var$svg,
            label: label,
            type: "rovo",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function RovoHexLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $23f94ca63efd0f1b$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $63a5cd591bbe1860$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z"/>
    <path fill="var(--icon-color, white)" d="M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691"/>
</svg>
`;
const $63a5cd591bbe1860$export$e23ae35269442b4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Rovo" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $63a5cd591bbe1860$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function RovoIcon({ size: size, appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $63a5cd591bbe1860$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $3fcd503bee83d588$var$svg = `<svg height="100%" viewBox="0 0 106 32">
    <path fill="var(--text-color, #1e1f21)" d="M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z"/>
    <path fill="var(--icon-color, white)" d="m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1"/>
</svg>
`;
const $3fcd503bee83d588$export$b0e15f0a1c9f4c55 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Rovo" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $3fcd503bee83d588$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function RovoLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $3fcd503bee83d588$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $30f6c98f7a9f5db7$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z" clip-rule="evenodd"/>
</svg>
`;
const $30f6c98f7a9f5db7$export$82eafebb825fc23f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SearchIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Search" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $30f6c98f7a9f5db7$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function SearchIcon({ size: size, appearance: appearance = 'brand', label: label = 'Search', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $30f6c98f7a9f5db7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $3fe64b3527f4ede0$var$svg = `<svg height="100%" viewBox="0 0 130 32">
    <path fill="var(--text-color, #1e1f21)" d="M128.82 16.35v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.05 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M14.346 22.068a7.721 7.721 0 1 1 6.718-3.913l4.537 4.536-2.94 2.94-4.545-4.545a7.7 7.7 0 0 1-3.77.982m-.364-12.494-.323.82c-.459 1.167-.688 1.75-1.112 2.188-.423.44-.997.69-2.146 1.19l-.492.214v.68l.492.213c1.149.5 1.723.75 2.146 1.19.424.439.653 1.022 1.112 2.188l.323.82h.679l.323-.82c.459-1.166.688-1.75 1.111-2.188.424-.44.998-.69 2.147-1.19l.491-.214v-.679l-.491-.214c-1.149-.5-1.723-.75-2.147-1.19-.423-.438-.652-1.021-1.111-2.187l-.323-.82z" clip-rule="evenodd"/>
</svg>
`;
const $3fe64b3527f4ede0$export$fa08cbfe393f2a68 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SearchLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Search" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $3fe64b3527f4ede0$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function SearchLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Search', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $3fe64b3527f4ede0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $9e3e0c0bdf270fb9$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68"/>
</svg>
`;
const $9e3e0c0bdf270fb9$export$f3f5aa321d88adf9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StatuspageIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Statuspage" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $9e3e0c0bdf270fb9$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function StatuspageIcon({ size: size, appearance: appearance = 'brand', label: label = 'Statuspage', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $9e3e0c0bdf270fb9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $f9be60ecf51b7acc$var$svg = `<svg height="100%" viewBox="0 0 192 32">
    <path fill="var(--text-color, #1e1f21)" d="M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927"/>
</svg>
`;
const $f9be60ecf51b7acc$export$2bc88a281410ffa7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StatuspageLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Statuspage" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $f9be60ecf51b7acc$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function StatuspageLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Statuspage', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $f9be60ecf51b7acc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $fc333c1189a718fd$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z"/>
</svg>
`;
const $fc333c1189a718fd$export$290a0f24614cde9f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StudioIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Studio" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $fc333c1189a718fd$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function StudioIcon({ size: size, appearance: appearance = 'brand', label: label = 'Studio', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $fc333c1189a718fd$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $2829a2c10c350b24$var$svg = `<svg height="100%" viewBox="0 0 124 32">
    <path fill="var(--text-color, #1e1f21)" d="M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M14.125 24.75V14.125H24.75V24.75zm5.078-8.65-.218.571c-.312.82-.469 1.23-.762 1.541s-.694.49-1.494.85l-.295.133v.476l.295.133c.8.36 1.2.54 1.494.85.293.311.45.721.762 1.541l.218.572h.462l.218-.572c.313-.82.469-1.23.762-1.54s.694-.491 1.494-.851l.295-.133v-.476l-.295-.132c-.8-.36-1.2-.54-1.494-.85-.293-.312-.45-.722-.762-1.542l-.218-.571z" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z"/>
</svg>
`;
const $2829a2c10c350b24$export$273fd56580e523ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StudioLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Studio" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $2829a2c10c350b24$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function StudioLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Studio', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $2829a2c10c350b24$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $fb0eeb73da830bbb$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786" clip-rule="evenodd"/>
</svg>
`;
const $fb0eeb73da830bbb$export$4b05688514531169 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TalentIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Talent" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $fb0eeb73da830bbb$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function TalentIcon({ size: size, appearance: appearance = 'brand', label: label = 'Talent', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $fb0eeb73da830bbb$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $b61db8c2aa610030$var$svg = `<svg height="100%" viewBox="0 0 122 32">
    <path fill="var(--text-color, #1e1f21)" d="M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>
    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714"/>
</svg>
`;
const $b61db8c2aa610030$export$1b3979d995ebbc6e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TalentLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Talent" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $b61db8c2aa610030$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function TalentLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Talent', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $b61db8c2aa610030$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $1576217052e14df9$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63"/>
</svg>
`;
const $1576217052e14df9$export$1bcbc9c337da86da = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TeamsIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Teams" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $1576217052e14df9$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function TeamsIcon({ size: size, appearance: appearance = 'brand', label: label = 'Teams', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $1576217052e14df9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $75f435ea45793f46$var$svg = `<svg height="100%" viewBox="0 0 127 32">
    <path fill="var(--text-color, #1e1f21)" d="M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08"/>
</svg>
`;
const $75f435ea45793f46$export$bfd8d1c4da84ce71 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TeamsLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Teams" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $75f435ea45793f46$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function TeamsLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Teams', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $75f435ea45793f46$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};














// `height` is set to 100% to allow the SVG to scale with the parent element
const $24d0e9af25866402$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1558bc)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z"/>
</svg>
`;
const $24d0e9af25866402$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z"/>
</svg>
`;
const $24d0e9af25866402$export$4384da9b8b140bf4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TrelloIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Trello" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $24d0e9af25866402$var$svg,
            customThemeSvg: $24d0e9af25866402$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function TrelloIcon({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Trello', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $24d0e9af25866402$var$svg,
        customThemeSvg: $24d0e9af25866402$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};












// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $66aaedd900351ebd$var$svg = `<svg height="100%" viewBox="0 0 113 32">
    <path fill="var(--text-color, #1e1f21)" d="M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>
    <path fill="var(--tile-color,#1558bc)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z"/>
</svg>
`;
const $66aaedd900351ebd$export$1b13139dfc0336af = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TrelloLogoCS(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Trello" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
            svg: $66aaedd900351ebd$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function TrelloLogoCS({ size: size, appearance: appearance = 'brand', label: label = 'Trello', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf4ce054ddb9b6b$export$f827d3c5a9c3f644), {
        svg: $66aaedd900351ebd$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};



var $6YXrY = parcelRequire("6YXrY");




const $0d1b924fd1766085$export$436fcf6e31fbacea = (_LegacyComponent, NewComponent)=>{
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return ({ size: size, shouldUseNewLogoDesign: _shouldUseNewLogoDesign, ...props })=>{
        // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(NewComponent, {
            size: size || 'medium',
            ...props
        });
    };
};















var $2JKQ0 = parcelRequire("2JKQ0");


var $ihy5X = parcelRequire("ihy5X");


var $kejsE = parcelRequire("kejsE");

const $f1fb53a8210903e4$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
      <path
        d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $f1fb53a8210903e4$export$84109e099492cb5f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, textColor: t3, iconColor: t4 } = t0;
    const label = t1 === undefined ? "Atlassian Admin" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const textColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t3;
    const iconColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $f1fb53a8210903e4$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            svg: t5,
            iconColor: iconColor,
            label: label,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Atlassian Admin', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        svg: $f1fb53a8210903e4$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};






















const $6357de237d357e11$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg
      fill="none"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 295 32"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369"
        fill="${colors.textColor}"
      />
      <path
        d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $6357de237d357e11$export$f845d9b9254f0541 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, textColor: t3, iconColor: t4 } = t0;
    const label = t1 === undefined ? "Atlassian Admin" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const textColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t3;
    const iconColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $6357de237d357e11$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            iconColor: iconColor,
            label: label,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Atlassian Admin', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $6357de237d357e11$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};























const $f5a8514577405732$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
      <path
        d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $f5a8514577405732$export$74517ed253186308 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, textColor: t3, iconColor: t4 } = t0;
    const label = t1 === undefined ? "Atlassian Administration" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const textColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t3;
    const iconColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $f5a8514577405732$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            svg: t5,
            iconColor: iconColor,
            label: label,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Atlassian Administration', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        svg: $f5a8514577405732$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};






















const $e61f2a6004991b89$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg
      fill="none"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 404 32"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369"
        fill="${colors.textColor}"
      />
      <path
        d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $e61f2a6004991b89$export$833abe6c2ce5ebfd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, textColor: t3, iconColor: t4 } = t0;
    const label = t1 === undefined ? "Atlassian Administration" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const textColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t3;
    const iconColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $e61f2a6004991b89$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            iconColor: iconColor,
            label: label,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Atlassian Administration', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $e61f2a6004991b89$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};












var $6JrSr = parcelRequire("6JrSr");











var $cPYuK = parcelRequire("cPYuK");

const $f0fb6112416ab4cc$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cPYuK.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `<svg height="32" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="${id}-a" x1="12.595" x2="12.595" y1="40" y2="30" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="${colors.iconGradientStart}"/>
      <stop offset="1" stop-color="${colors.iconGradientStop}"/>
    </linearGradient>
    <linearGradient id="${id}-b" x1="28.595" x2="28.595" y1="40" y2="27" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="${colors.iconGradientStart}"/>
      <stop offset="1" stop-color="${colors.iconGradientStop}"/>
    </linearGradient>
    <linearGradient xlink:href="#${id}-b" id="${id}-c" x1="20.595" x2="20.595" y2="22"/>
    <linearGradient xlink:href="#${id}-b" id="${id}-d" x1="36.595" x2="36.595" y2="20"/>
  </defs>
  <path d="M10.595 30h4v10h-4z" fill="url(#${id}-a)"/>
  <path d="M26.595 27h4v13h-4z" fill="url(#${id}-b)"/>
  <path d="M18.595 22h4v18h-4z" fill="url(#${id}-c)"/>
  <path d="M34.595 20h4v20h-4z" fill="url(#${id}-d)"/>
  <path fill="${colors.iconColor}" d="m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z" />
</svg>`;
};
const $f0fb6112416ab4cc$export$c42ad8a0b925c762 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, iconColor: t3, textColor: t4, testId: testId } = t0;
    const label = t1 === undefined ? "Atlassian Analytics" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const id = (0, $6JrSr.useId)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== id) {
        t5 = $f0fb6112416ab4cc$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = id;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            svg: t5,
            iconColor: iconColor,
            textColor: textColor,
            size: size,
            testId: testId
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Atlassian Analytics', size: size = (0, $2JKQ0.defaultLogoParams).size, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const id = (0, $6JrSr.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        svg: $f0fb6112416ab4cc$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

























const $3772e3ae55aaa35d$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $cPYuK.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
  <svg height="32" viewBox="0 0 477 48" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="${id}-a" x1="447.285" x2="447.285" y1="40" y2="30" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="${colors.iconGradientStart}"/>
      <stop offset="1" stop-color="${colors.iconGradientStop}"/>
    </linearGradient>
    <linearGradient xlink:href="#${id}-a" id="${id}-b" x1="463.285" x2="463.285" y2="27"/>
    <linearGradient xlink:href="#${id}-a" id="${id}-c" x1="455.285" x2="455.285" y2="22"/>
    <linearGradient xlink:href="#${id}-a" id="${id}-d" x1="471.285" x2="471.285" y2="20"/>
  </defs>
  <g fill="${colors.atlassianLogoTextColor}">
    <path d="M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z"/>
  </g>
  <g fill="${colors.textColor}">
    <path d="m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z"/>
  </g>
  <path fill="url(#${id}-a)" d="M445.285 30h4v10h-4z"/>
  <path fill="url(#${id}-b)" d="M461.285 27h4v13h-4z"/>
  <path fill="url(#${id}-c)" d="M453.285 22h4v18h-4z"/>
  <path fill="url(#${id}-d)" d="M469.285 20h4v20h-4z"/>
  <path fill="${colors.iconColor}" d="m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z"/>
</svg>`;
};
const $3772e3ae55aaa35d$export$e6470bfc39010cc4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Atlassian Analytics" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const id = (0, $6JrSr.useId)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== id || $[4] !== textColor) {
        t5 = $3772e3ae55aaa35d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = id;
        $[4] = textColor;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== appearance || $[7] !== iconColor || $[8] !== label || $[9] !== size || $[10] !== t5 || $[11] !== testId || $[12] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            size: size,
            iconColor: iconColor,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[6] = appearance;
        $[7] = iconColor;
        $[8] = label;
        $[9] = size;
        $[10] = t5;
        $[11] = testId;
        $[12] = textColor;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : ({ appearance: appearance, label: label = 'Atlassian Analytics', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const id = (0, $6JrSr.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $3772e3ae55aaa35d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};























const $d7fc8f7220d4efe3$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>
    </svg>`;
};
const $d7fc8f7220d4efe3$export$5fc1066e677788d4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Bitbucket" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $d7fc8f7220d4efe3$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            svg: t5,
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        svg: $d7fc8f7220d4efe3$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};






















const $3fee1c45816242c3$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 158 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
        <path fill=${colors.iconColor} d="m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95"/>
        <path fill=${colors.textColor} d="M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z"/>
      </svg>`;
};
const $3fee1c45816242c3$export$bd40525f5333524b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Bitbucket" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $3fee1c45816242c3$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $3fee1c45816242c3$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};























const $f819fb606edf443f$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z"/>
      </svg>
    `;
};
const $f819fb606edf443f$export$f7857fe64d7161d9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Compass" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $f819fb606edf443f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            svg: t5,
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Compass', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        svg: $f819fb606edf443f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};






















const $7bea2fa726b850cd$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 155 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
    <path fill=${colors.iconColor} d="M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z"/>
    <path fill="${colors.textColor}" d="M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227"/>
  </svg>`;
};
const $7bea2fa726b850cd$export$eb7d748e4f9c9676 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Compass" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $7bea2fa726b850cd$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Compass', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $7bea2fa726b850cd$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $8UJqr = parcelRequire("8UJqr");





















const $cedccc4c510ebaef$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 180 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098"/>
      <path fill="${colors.textColor}" d="M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227"/>
    </svg>
    `;
};
const $cedccc4c510ebaef$export$1b2e4fe6ef471556 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Confluence" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $cedccc4c510ebaef$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $cedccc4c510ebaef$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};























const $a1af31cdb4e62593$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 48 48" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
		<path fill="${colors.iconColor}" d="M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z"/>
		</svg>
		`;
};
const $a1af31cdb4e62593$export$1e02e7298035a77c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Focus" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $a1af31cdb4e62593$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            svg: t5,
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Focus', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        svg: $a1af31cdb4e62593$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};






















const $1f06ba8037ac8eae$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 168 48" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
		<path fill="${colors.iconColor}" d="M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z"/>
		<path fill="${colors.textColor}" d="M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z"/>
		<path fill="${colors.textColor}" d="M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z"/>
		<path fill="${colors.textColor}" d="M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z"/>
		<path fill="${colors.textColor}" d="M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z"/>
		<path fill="${colors.textColor}" d="M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z"/>
		</svg>
		`;
};
const $1f06ba8037ac8eae$export$33908560ea1b226d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Focus" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $1f06ba8037ac8eae$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Focus', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $1f06ba8037ac8eae$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};























const $9be3efca76cf8e0b$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
      <path
        d="M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $9be3efca76cf8e0b$export$3f95fcfdc25a741d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, textColor: t3, iconColor: t4 } = t0;
    const label = t1 === undefined ? "Guard" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const textColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t3;
    const iconColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $9be3efca76cf8e0b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            svg: t5,
            iconColor: iconColor,
            label: label,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Guard', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        svg: $9be3efca76cf8e0b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};






















const $b4bfda3c96cebf24$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114 32" focusable="false" aria-hidden="true">
      <path
        d="M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038"
        fill="${colors.iconColor}"
      />
      <path
        d="M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z"
        fill="${colors.textColor}"
      />
    </svg>`;
};
const $b4bfda3c96cebf24$export$a4a891d202775deb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, textColor: t3, iconColor: t4 } = t0;
    const label = t1 === undefined ? "Guard" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const textColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t3;
    const iconColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $b4bfda3c96cebf24$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            iconColor: iconColor,
            label: label,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Guard', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $b4bfda3c96cebf24$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $aK5FI = parcelRequire("aK5FI");





















const $ad86f695633c9c0c$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 77 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
      <path fill="${colors.textColor}" d="M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404"/>
    </svg>`;
};
const $ad86f695633c9c0c$export$17d3acb0b4379d02 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Jira" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $ad86f695633c9c0c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Jira', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $ad86f695633c9c0c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};























const $cf233f1fc9013d7e$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg viewBox="0 0 32 32" focusable="false" aria-hidden="true" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="${colors.iconColor}"
      d="M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z"
    />
  </svg>`;
};
const $cf233f1fc9013d7e$export$407687b2dd89cc68 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, textColor: t3, iconColor: t4 } = t0;
    const label = t1 === undefined ? "Jira Align" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const textColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t3;
    const iconColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $cf233f1fc9013d7e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            svg: t5,
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Jira Align', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        svg: $cf233f1fc9013d7e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};






















const $2b35998c09c96bc8$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg viewBox="0 0 146 32" focusable="false" aria-hidden="true" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z" fill="${colors.iconColor}"/>
      <path d="M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" fill="${colors.textColor}"/>
    </svg>
  `;
};
const $2b35998c09c96bc8$export$ee11e928d3d045fd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Jira Align" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $2b35998c09c96bc8$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Jira Align', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $2b35998c09c96bc8$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};























const $86cbcb9c4c8eefcc$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z"/>
    </svg>`;
};
const $86cbcb9c4c8eefcc$export$21bfbeb62fdcce8d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Jira Product Discovery" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $86cbcb9c4c8eefcc$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            svg: t5,
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        svg: $86cbcb9c4c8eefcc$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};






















const $db156b4f4a4dadfe$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 318 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z" />
      <path fill="${colors.textColor}" d="M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $db156b4f4a4dadfe$export$c49a2b642fe9eef4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Jira Product Discovery" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $db156b4f4a4dadfe$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $db156b4f4a4dadfe$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};























const $a25de2a5bf72f674$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z"/>
    </svg>`;
};
const $a25de2a5bf72f674$export$3c6158790f5e01c4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Jira Service Management" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $a25de2a5bf72f674$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            svg: t5,
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        svg: $a25de2a5bf72f674$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};






















const $816f2692f2e19e8b$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 362 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z" />
      <path fill=${colors.textColor} d="M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $816f2692f2e19e8b$export$dabef2be6cd28c20 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Jira Service Management" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $816f2692f2e19e8b$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $816f2692f2e19e8b$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $lfEjj = parcelRequire("lfEjj");



















var $lH46a = parcelRequire("lH46a");

const $f09d9648ae63bcef$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $lH46a.getColorsForLoom)(appearance, colorMode);
    return `<svg
      fill="none"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 98 32"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006"
        fill="${colors.iconColor}"
      />
      <path
        d="M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247"
        fill="${colors.textColor}"
      />
    </svg>`;
};
const $f09d9648ae63bcef$export$94e206806e36c2ec = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Loom" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $f09d9648ae63bcef$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Loom', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $f09d9648ae63bcef$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

















const $3129d3b3de965421$export$1bf47cdade1a9fcb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Loom Attribution" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    let t5;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId || $[5] !== textColor) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfEjj.LoomIcon), {
            appearance: appearance,
            label: label,
            size: size,
            testId: testId,
            iconColor: iconColor,
            textColor: textColor
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = textColor;
        $[6] = t5;
    } else t5 = $[6];
    return t5;
} : ({ appearance: appearance, label: label = 'Loom Attribution', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfEjj.LoomIcon), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};






















const $73c5123476f36862$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $lH46a.getColorsForLoom)(appearance, colorMode);
    return `<svg
		fill="none"
		height="32"
		xmlns="http://www.w3.org/2000/svg"
		focusable="false"
		aria-hidden="true"
		viewBox="0 0 88 32"
	>
		<path
			d="M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058"
			fill="${colors.iconColor}"
		/>
		<path
			d="M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z"
			fill="${colors.textColor}"
		/>
	</svg>`;
};
const $73c5123476f36862$export$6e87ce8d41eda665 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Loom Attribution" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $73c5123476f36862$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Loom Attribution', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $73c5123476f36862$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};























const $1baa4a88b083442e$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156"/>
    </svg>`;
};
const $1baa4a88b083442e$export$eeccc49dc7a12d9f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, textColor: t3, iconColor: t4 } = t0;
    const label = t1 === undefined ? "Opsgenie" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const textColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t3;
    const iconColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $1baa4a88b083442e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            svg: t5,
            iconColor: iconColor,
            label: label,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Opsgenie', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        svg: $1baa4a88b083442e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};






















const $dbe472a689350451$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 154 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156"/>
      <path fill="${colors.textColor}" d="M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697" />
    </svg>`;
};
const $dbe472a689350451$export$a1c6484cdecc2c4b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, textColor: t3, iconColor: t4 } = t0;
    const label = t1 === undefined ? "Opsgenie" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const textColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t3;
    const iconColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $dbe472a689350451$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            iconColor: iconColor,
            label: label,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Opsgenie', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $dbe472a689350451$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};























const $8d2bd94ecd73d5d7$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
    <g fill="${colors.iconColor}" fill-rule="evenodd">
      <path d="M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z"/>
      <path d="m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z"/>
    </g>
  </svg>`;
};
const $8d2bd94ecd73d5d7$export$e23ae35269442b4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, textColor: t3, iconColor: t4 } = t0;
    const label = t1 === undefined ? "Rovo" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const textColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t3;
    const iconColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $8d2bd94ecd73d5d7$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            svg: t5,
            iconColor: iconColor,
            label: label,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Rovo', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        svg: $8d2bd94ecd73d5d7$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};






















const $9333bad284407e1b$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 100 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z"
        fill="${colors.iconColor}"
        fillRule="evenodd"
      />
      <path
        d="m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z"
        fill="${colors.iconColor}"
        fillRule="evenodd"
      />
      <path
        d="M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z"
        fill="${colors.textColor}"
      />
    </svg>`;
};
const $9333bad284407e1b$export$a0f6cb8061290bbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, textColor: t3, iconColor: t4 } = t0;
    const label = t1 === undefined ? "Rovo" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const textColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t3;
    const iconColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $9333bad284407e1b$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            iconColor: iconColor,
            label: label,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Rovo', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $9333bad284407e1b$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};























const $33ed90a8ec02ed8e$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063"/>
    </svg>`;
};
const $33ed90a8ec02ed8e$export$f3f5aa321d88adf9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Statuspage" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $33ed90a8ec02ed8e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            svg: t5,
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Statuspage', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        svg: $33ed90a8ec02ed8e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};






















const $0579a67076cf2567$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 188 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063" />
      <path fill="${colors.textColor}" d="M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072" />
    </svg>`;
};
const $0579a67076cf2567$export$bb4ae5b41b43be04 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Statuspage" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $0579a67076cf2567$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Statuspage', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $0579a67076cf2567$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};























const $c6fad43c427301ff$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} clip-rule="evenodd" d="M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z" fill-rule="evenodd"/>
    </svg>`;
};
const $c6fad43c427301ff$export$4384da9b8b140bf4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Trello" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $c6fad43c427301ff$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            svg: t5,
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Trello', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        svg: $c6fad43c427301ff$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};






















const $8a5662c4899cbfc4$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 106 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" clip-rule="evenodd" d="M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z" fill-rule="evenodd"/>
      <path fill="${colors.textColor}" d="M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z"/>
    </svg>`;
};
const $8a5662c4899cbfc4$export$60e26212f3b61a28 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Trello" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== textColor) {
        t5 = $8a5662c4899cbfc4$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = textColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Trello', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $8a5662c4899cbfc4$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $iXV0W = parcelRequire("iXV0W");

var $lNhWn = parcelRequire("lNhWn");


var $3FmCf = parcelRequire("3FmCf");

var $2CnS6 = parcelRequire("2CnS6");


var $h47pR = parcelRequire("h47pR");

var $6aKgW = parcelRequire("6aKgW");


var $9opDp = parcelRequire("9opDp");

var $dnlpr = parcelRequire("dnlpr");


var $NlHoa = parcelRequire("NlHoa");

var $kbI17 = parcelRequire("kbI17");


var $llfZq = parcelRequire("llfZq");

var $cwhx1 = parcelRequire("cwhx1");





var $hcVQz = parcelRequire("hcVQz");




const $69dd162884c718e4$export$2469203854060337 = (_LegacyComponent, _NewComponent, NewHexComponent)=>{
    const RovoHexWrapped = (0, $hcVQz.tempSizeWrapper)(NewHexComponent);
    return ({ shouldUseHexLogo: _shouldUseHexLogo, ...props })=>{
        // Hex logo is now always used (platform-logo-rebrand-rovo-hex fully launched)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RovoHexWrapped, props);
    };
};





const $a40c4420af70b5a2$export$ef8e5f836dd989d3 = (0, $hcVQz.tempSizeWrapper)((0, $03276b3d04b76dd1$export$ef8e5f836dd989d3));
const $a40c4420af70b5a2$export$ebcd30672e67406 = (0, $hcVQz.tempSizeWrapper)((0, $b9ab5b9d03a978e6$export$61afcb38c001e19));
const $a40c4420af70b5a2$export$af3460f51ce3602a = (0, $hcVQz.tempSizeWrapper)((0, $13419d6b173b736d$export$af3460f51ce3602a));
const $a40c4420af70b5a2$export$c8415b6abe4a8587 = (0, $hcVQz.tempSizeWrapper)((0, $d5eb558efb1e3f94$export$f0bac2b7ac3e3504));
const $a40c4420af70b5a2$export$d89497e7f33ca6f5 = (0, $hcVQz.tempSizeWrapper)((0, $83056c684d55bb4d$export$d89497e7f33ca6f5));
const $a40c4420af70b5a2$export$48ca930f3071e3e4 = (0, $hcVQz.tempSizeWrapper)((0, $025c567fc54454f6$export$81c47abe19675c4c));
const $a40c4420af70b5a2$export$52cd484a7ef4f2b9 = (0, $hcVQz.tempSizeWrapper)((0, $bbc4e0366bfee3cc$export$52cd484a7ef4f2b9));
const $a40c4420af70b5a2$export$9ca9881809919df8 = (0, $hcVQz.tempSizeWrapper)((0, $4941f3d709f353e7$export$a529e78951cd6709));
const $a40c4420af70b5a2$export$6da5aa77c402ba0f = (0, $hcVQz.tempSizeWrapper)((0, $4f22854d02c31273$export$6da5aa77c402ba0f));
const $a40c4420af70b5a2$export$abc95e6180bb1d88 = (0, $hcVQz.tempSizeWrapper)((0, $90490e8b2c406928$export$f597f0f7fadce0b9));
const $a40c4420af70b5a2$export$34420f0520b19b1d = (0, $hcVQz.tempSizeWrapper)((0, $abe90306ef3e27a5$export$34420f0520b19b1d));
const $a40c4420af70b5a2$export$c9696eb3c34c5a96 = (0, $hcVQz.tempSizeWrapper)((0, $4c8210cc6f9fba72$export$bbccafb125ebd50c));
const $a40c4420af70b5a2$export$9eb74917ea768ed4 = (0, $hcVQz.tempSizeWrapper)((0, $ad20b5467f7f9ada$export$9eb74917ea768ed4));
const $a40c4420af70b5a2$export$d2577aa28451395f = (0, $hcVQz.tempSizeWrapper)((0, $ce22f23b1949f489$export$c527a545aa426db3));
const $a40c4420af70b5a2$export$92c8767b874048d = (0, $hcVQz.tempSizeWrapper)((0, $9255a8fd6323cfc1$export$92c8767b874048d));
const $a40c4420af70b5a2$export$d5648119d5b68e90 = (0, $hcVQz.tempSizeWrapper)((0, $bef638fba914ccdd$export$8b6b7f1b1b2367d3));
const $a40c4420af70b5a2$export$80b8b269d8b5014e = (0, $hcVQz.tempSizeWrapper)((0, $841a22a6d07f9832$export$80b8b269d8b5014e));
const $a40c4420af70b5a2$export$fc9bd6687b80fe3b = (0, $hcVQz.tempSizeWrapper)((0, $13f5db28dc876d37$export$7a38180641471460));
const $a40c4420af70b5a2$export$5ed3e1bb3b04fc02 = (0, $hcVQz.tempSizeWrapper)((0, $87b9bf478c0c1673$export$5ed3e1bb3b04fc02));
const $a40c4420af70b5a2$export$aeefab651bcf2338 = (0, $hcVQz.tempSizeWrapper)((0, $702f9f52344cd4d9$export$e3d1678155aaab99));
const $a40c4420af70b5a2$export$8b784b3227531b3e = (0, $hcVQz.tempSizeWrapper)((0, $50837398edad00a7$export$8b784b3227531b3e));
const $a40c4420af70b5a2$export$f0750468d67c6902 = (0, $hcVQz.tempSizeWrapper)((0, $fc2002c31bb68cd3$export$4145bd793c9ed1d0));
const $a40c4420af70b5a2$export$813cff80931d9dbf = (0, $hcVQz.tempSizeWrapper)((0, $1eb0ba52efd1ec9a$export$813cff80931d9dbf));
const $a40c4420af70b5a2$export$409b7a5b7f180eba = (0, $hcVQz.tempSizeWrapper)((0, $204c4a4a1c49503e$export$58747af448450872));
const $a40c4420af70b5a2$export$b12fec207e8537a8 = (0, $hcVQz.tempSizeWrapper)((0, $be05cd4e46cc9418$export$b12fec207e8537a8));
const $a40c4420af70b5a2$export$82eafebb825fc23f = (0, $hcVQz.tempSizeWrapper)((0, $30f6c98f7a9f5db7$export$82eafebb825fc23f));
const $a40c4420af70b5a2$export$e4c5487c9a8ae3b1 = (0, $hcVQz.tempSizeWrapper)((0, $3fe64b3527f4ede0$export$fa08cbfe393f2a68));
const $a40c4420af70b5a2$export$290a0f24614cde9f = (0, $hcVQz.tempSizeWrapper)((0, $fc333c1189a718fd$export$290a0f24614cde9f));
const $a40c4420af70b5a2$export$8aceb78c659789b6 = (0, $hcVQz.tempSizeWrapper)((0, $2829a2c10c350b24$export$273fd56580e523ae));
const $a40c4420af70b5a2$export$4b05688514531169 = (0, $hcVQz.tempSizeWrapper)((0, $fb0eeb73da830bbb$export$4b05688514531169));
const $a40c4420af70b5a2$export$4f6453e012279f89 = (0, $hcVQz.tempSizeWrapper)((0, $b61db8c2aa610030$export$1b3979d995ebbc6e));
const $a40c4420af70b5a2$export$1bcbc9c337da86da = (0, $hcVQz.tempSizeWrapper)((0, $1576217052e14df9$export$1bcbc9c337da86da));
const $a40c4420af70b5a2$export$9b1a0a0c574cec2a = (0, $hcVQz.tempSizeWrapper)((0, $75f435ea45793f46$export$bfd8d1c4da84ce71));
const $a40c4420af70b5a2$export$e812398311cab9a3 = (0, $hcVQz.tempSizeWrapper)((0, $e6d7a17105c18a62$export$e812398311cab9a3));
const $a40c4420af70b5a2$export$765f5afcc1a5a7e3 = (0, $hcVQz.tempSizeWrapper)((0, $7713916fd1b85a1e$export$7c51958462d750e));
const $a40c4420af70b5a2$export$d3ab16bbf4f954ee = (0, $hcVQz.tempSizeWrapper)((0, $aba0f5cd4314443d$export$d3ab16bbf4f954ee));
const $a40c4420af70b5a2$export$36044946916e84a0 = (0, $hcVQz.tempSizeWrapper)((0, $bff633c1c17e420e$export$cc55e2a4c4b40552));
const $a40c4420af70b5a2$export$53305f1f2855d3be = (0, $hcVQz.tempSizeWrapper)((0, $2e5df0b036034f27$export$53305f1f2855d3be));
const $a40c4420af70b5a2$export$5e06396bce773a3 = (0, $hcVQz.tempSizeWrapper)((0, $66c39101e57479f4$export$b3e508cb103e1f93));
const $a40c4420af70b5a2$export$eaf73f391f7103bd = (0, $hcVQz.tempSizeWrapper)((0, $f6cd25d2c8e75fff$export$eaf73f391f7103bd));
const $a40c4420af70b5a2$export$6128b385660fd3c6 = (0, $hcVQz.tempSizeWrapper)((0, $eaf1114a279cc25b$export$3c371bdbcdfcdce));
const $a40c4420af70b5a2$export$f8455b5667a3ee0c = (0, $hcVQz.tempSizeWrapper)((0, $19e672ea9865e4df$export$f8455b5667a3ee0c));
const $a40c4420af70b5a2$export$eb152ab3801b2ae3 = (0, $hcVQz.tempSizeWrapper)((0, $2830ebef819e6a54$export$3224b07bc93ef23e));
const $a40c4420af70b5a2$export$65fae0eaf343f2ca = (0, $hcVQz.tempSizeWrapper)((0, $712f916716e5e7e0$export$65fae0eaf343f2ca));
const $a40c4420af70b5a2$export$fffc0d480fb1ebf1 = (0, $hcVQz.tempSizeWrapper)((0, $7cc171059637a3ab$export$f64bc7a7f04428d0));
const $a40c4420af70b5a2$export$74517ed253186308 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $f5a8514577405732$export$74517ed253186308), (0, $03276b3d04b76dd1$export$ef8e5f836dd989d3));
const $a40c4420af70b5a2$export$833abe6c2ce5ebfd = (0, $6YXrY.createFeatureFlaggedComponent)((0, $e61f2a6004991b89$export$833abe6c2ce5ebfd), (0, $b9ab5b9d03a978e6$export$61afcb38c001e19));
const $a40c4420af70b5a2$export$84109e099492cb5f = (0, $6YXrY.createFeatureFlaggedComponent)((0, $f1fb53a8210903e4$export$84109e099492cb5f), (0, $03276b3d04b76dd1$export$ef8e5f836dd989d3));
const $a40c4420af70b5a2$export$f845d9b9254f0541 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $6357de237d357e11$export$f845d9b9254f0541), (0, $b9ab5b9d03a978e6$export$61afcb38c001e19));
const $a40c4420af70b5a2$export$c42ad8a0b925c762 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $f0fb6112416ab4cc$export$c42ad8a0b925c762), (0, $13419d6b173b736d$export$af3460f51ce3602a));
const $a40c4420af70b5a2$export$e6470bfc39010cc4 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $3772e3ae55aaa35d$export$e6470bfc39010cc4), (0, $d5eb558efb1e3f94$export$f0bac2b7ac3e3504));
const $a40c4420af70b5a2$export$5fc1066e677788d4 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $d7fc8f7220d4efe3$export$5fc1066e677788d4), (0, $d28d5aedb34440f3$export$5fc1066e677788d4));
const $a40c4420af70b5a2$export$bd40525f5333524b = (0, $6YXrY.createFeatureFlaggedComponent)((0, $3fee1c45816242c3$export$bd40525f5333524b), (0, $96587aa986e6fd29$export$f7ef5e5488e4b430));
const $a40c4420af70b5a2$export$f7857fe64d7161d9 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $f819fb606edf443f$export$f7857fe64d7161d9), (0, $08074ca1ab8ce06c$export$f7857fe64d7161d9));
const $a40c4420af70b5a2$export$eb7d748e4f9c9676 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $7bea2fa726b850cd$export$eb7d748e4f9c9676), (0, $a403e2ffb4d2e315$export$a16f50a81d183ce));
const $a40c4420af70b5a2$export$9951d02c2d848122 = (0, $hcVQz.tempSizeWrapper)((0, $a72594f5636889fa$export$9951d02c2d848122));
const $a40c4420af70b5a2$export$68f3db7f6af48bcb = (0, $6YXrY.createFeatureFlaggedComponent)((0, $8UJqr.ConfluenceIcon), (0, $5lkNm.ConfluenceIcon));
const $a40c4420af70b5a2$export$1b2e4fe6ef471556 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $cedccc4c510ebaef$export$1b2e4fe6ef471556), (0, $1c9a1ac3a4cee6e2$export$a88b0b0da9ef63ce));
const $a40c4420af70b5a2$export$70a0c2f5862937b6 = (0, $hcVQz.tempSizeWrapper)((0, $1e1cc794ed57e6b4$export$70a0c2f5862937b6));
const $a40c4420af70b5a2$export$1b8596b4b0ef673b = (0, $hcVQz.tempSizeWrapper)((0, $709af12c753ebbf9$export$8b5103382c06639c));
const $a40c4420af70b5a2$export$407687b2dd89cc68 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $cf233f1fc9013d7e$export$407687b2dd89cc68), (0, $1e1cc794ed57e6b4$export$70a0c2f5862937b6));
const $a40c4420af70b5a2$export$ee11e928d3d045fd = (0, $6YXrY.createFeatureFlaggedComponent)((0, $2b35998c09c96bc8$export$ee11e928d3d045fd), (0, $709af12c753ebbf9$export$8b5103382c06639c));
const $a40c4420af70b5a2$export$c4b5b1f965d8b3eb = (0, $6YXrY.createFeatureFlaggedComponent)((0, $aK5FI.JiraIcon), (0, $ldJ1U.JiraIcon));
const $a40c4420af70b5a2$export$17d3acb0b4379d02 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $ad86f695633c9c0c$export$17d3acb0b4379d02), (0, $b1390b168e69241b$export$bf4c5f97b468e8d6));
const $a40c4420af70b5a2$export$21bfbeb62fdcce8d = (0, $6YXrY.createFeatureFlaggedComponent)((0, $86cbcb9c4c8eefcc$export$21bfbeb62fdcce8d), (0, $9f7a3b7caba550ed$export$21bfbeb62fdcce8d));
const $a40c4420af70b5a2$export$c49a2b642fe9eef4 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $db156b4f4a4dadfe$export$c49a2b642fe9eef4), (0, $43cf7dd3eda107a4$export$602140a6a10b02bf));
const $a40c4420af70b5a2$export$3c6158790f5e01c4 = (0, $0d1b924fd1766085$export$436fcf6e31fbacea)((0, $a25de2a5bf72f674$export$3c6158790f5e01c4), (0, $9d7fd522dc0dc942$export$3c6158790f5e01c4));
const $a40c4420af70b5a2$export$dabef2be6cd28c20 = (0, $0d1b924fd1766085$export$436fcf6e31fbacea)((0, $816f2692f2e19e8b$export$dabef2be6cd28c20), (0, $861d2782289acd74$export$de148263c75d2bc1));
const $a40c4420af70b5a2$export$8d789f76fde3e05 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $lfEjj.LoomIcon), (0, $lb2PL.LoomIcon));
const $a40c4420af70b5a2$export$94e206806e36c2ec = (0, $6YXrY.createFeatureFlaggedComponent)((0, $f09d9648ae63bcef$export$94e206806e36c2ec), (0, $b618dd54a2366839$export$78c0b4d8be34c9b2));
const $a40c4420af70b5a2$export$1bf47cdade1a9fcb = (0, $6YXrY.createFeatureFlaggedComponent)((0, $3129d3b3de965421$export$1bf47cdade1a9fcb), (0, $lb2PL.LoomIcon));
const $a40c4420af70b5a2$export$6e87ce8d41eda665 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $73c5123476f36862$export$6e87ce8d41eda665), (0, $3550bc2b37be7afe$export$68d7391318cdef11));
const $a40c4420af70b5a2$export$e84e925618e0e5bc = (0, $hcVQz.tempSizeWrapper)((0, $fc522095f7179715$export$71743a944cb62e48));
const $a40c4420af70b5a2$export$1940ba72c868b663 = (0, $hcVQz.tempSizeWrapper)((0, $b6ba3ab0a68971c2$export$38c7b37a3e5e8d70));
const $a40c4420af70b5a2$export$eeccc49dc7a12d9f = (0, $0d1b924fd1766085$export$436fcf6e31fbacea)((0, $1baa4a88b083442e$export$eeccc49dc7a12d9f), (0, $87e20010b263a529$export$eeccc49dc7a12d9f));
const $a40c4420af70b5a2$export$a1c6484cdecc2c4b = (0, $0d1b924fd1766085$export$436fcf6e31fbacea)((0, $dbe472a689350451$export$a1c6484cdecc2c4b), (0, $844f6e2073bb4d67$export$a5b9122e89b32ad3));
const $a40c4420af70b5a2$export$f3f5aa321d88adf9 = (0, $0d1b924fd1766085$export$436fcf6e31fbacea)((0, $33ed90a8ec02ed8e$export$f3f5aa321d88adf9), (0, $9e3e0c0bdf270fb9$export$f3f5aa321d88adf9));
const $a40c4420af70b5a2$export$bb4ae5b41b43be04 = (0, $0d1b924fd1766085$export$436fcf6e31fbacea)((0, $0579a67076cf2567$export$bb4ae5b41b43be04), (0, $f9be60ecf51b7acc$export$2bc88a281410ffa7));
const $a40c4420af70b5a2$export$4384da9b8b140bf4 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $c6fad43c427301ff$export$4384da9b8b140bf4), (0, $24d0e9af25866402$export$4384da9b8b140bf4));
const $a40c4420af70b5a2$export$60e26212f3b61a28 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $8a5662c4899cbfc4$export$60e26212f3b61a28), (0, $66aaedd900351ebd$export$1b13139dfc0336af));
const $a40c4420af70b5a2$export$e23ae35269442b4f = (0, $69dd162884c718e4$export$2469203854060337)((0, $8d2bd94ecd73d5d7$export$e23ae35269442b4f), (0, $63a5cd591bbe1860$export$e23ae35269442b4f), (0, $d73bd19527e99345$export$9e62346a60cfb459));
const $a40c4420af70b5a2$export$a0f6cb8061290bbb = (0, $69dd162884c718e4$export$2469203854060337)((0, $9333bad284407e1b$export$a0f6cb8061290bbb), (0, $3fcd503bee83d588$export$b0e15f0a1c9f4c55), (0, $23f94ca63efd0f1b$export$5e38d02efdb45577));
const $a40c4420af70b5a2$export$3f95fcfdc25a741d = (0, $6YXrY.createFeatureFlaggedComponent)((0, $9be3efca76cf8e0b$export$3f95fcfdc25a741d), (0, $29e11ce05e624c9c$export$3f95fcfdc25a741d));
const $a40c4420af70b5a2$export$a4a891d202775deb = (0, $6YXrY.createFeatureFlaggedComponent)((0, $b4bfda3c96cebf24$export$a4a891d202775deb), (0, $a715ce8ba7389c6a$export$2b896c4d595a4331));
const $a40c4420af70b5a2$export$1e02e7298035a77c = (0, $6YXrY.createFeatureFlaggedComponent)((0, $a1af31cdb4e62593$export$1e02e7298035a77c), (0, $b10ebbefbae983ec$export$1e02e7298035a77c));
const $a40c4420af70b5a2$export$33908560ea1b226d = (0, $6YXrY.createFeatureFlaggedComponent)((0, $1f06ba8037ac8eae$export$33908560ea1b226d), (0, $348690b5beae7695$export$3a6e8b37e069a69d));
const $a40c4420af70b5a2$export$5ef3f25e16249826 = (0, $hcVQz.tempSizeWrapper)((0, $c5c763fd1c1f1441$export$5ef3f25e16249826));
const $a40c4420af70b5a2$export$1ab0976b9ea166ae = (0, $hcVQz.tempSizeWrapper)((0, $257113bac26a9036$export$1ab0976b9ea166ae));
const $a40c4420af70b5a2$export$5efe8561ca252843 = (0, $hcVQz.tempSizeWrapper)((0, $9a9c3f6859fd2ed7$export$5efe8561ca252843));
const $a40c4420af70b5a2$export$e26e48d31d71c1e1 = (0, $hcVQz.tempSizeWrapper)((0, $e71fdb92b5ae56b0$export$e26e48d31d71c1e1));
const $a40c4420af70b5a2$export$bf5ca9fb70f56bb5 = (0, $hcVQz.tempSizeWrapper)((0, $1ea751a953e0497b$export$bf5ca9fb70f56bb5));
const $a40c4420af70b5a2$export$518f48548316ec87 = (0, $hcVQz.tempSizeWrapper)((0, $47ebd555be52a232$export$518f48548316ec87));
module.exports["AdminIcon"] = $a40c4420af70b5a2$export$ef8e5f836dd989d3;
module.exports["AdminLogo"] = $a40c4420af70b5a2$export$ebcd30672e67406;
module.exports["AnalyticsIcon"] = $a40c4420af70b5a2$export$af3460f51ce3602a;
module.exports["AnalyticsLogo"] = $a40c4420af70b5a2$export$c8415b6abe4a8587;
module.exports["AssetsIcon"] = $a40c4420af70b5a2$export$d89497e7f33ca6f5;
module.exports["AssetsLogo"] = $a40c4420af70b5a2$export$48ca930f3071e3e4;
module.exports["ChatIcon"] = $a40c4420af70b5a2$export$52cd484a7ef4f2b9;
module.exports["ChatLogo"] = $a40c4420af70b5a2$export$9ca9881809919df8;
module.exports["CustomerServiceManagementIcon"] = $a40c4420af70b5a2$export$6da5aa77c402ba0f;
module.exports["CustomerServiceManagementLogo"] = $a40c4420af70b5a2$export$abc95e6180bb1d88;
module.exports["FeedbackIcon"] = $a40c4420af70b5a2$export$34420f0520b19b1d;
module.exports["FeedbackLogo"] = $a40c4420af70b5a2$export$c9696eb3c34c5a96;
module.exports["GoalsIcon"] = $a40c4420af70b5a2$export$9eb74917ea768ed4;
module.exports["GoalsLogo"] = $a40c4420af70b5a2$export$d2577aa28451395f;
module.exports["HomeIcon"] = $a40c4420af70b5a2$export$92c8767b874048d;
module.exports["HomeLogo"] = $a40c4420af70b5a2$export$d5648119d5b68e90;
module.exports["HubIcon"] = $a40c4420af70b5a2$export$80b8b269d8b5014e;
module.exports["HubLogo"] = $a40c4420af70b5a2$export$fc9bd6687b80fe3b;
module.exports["ProjectsIcon"] = $a40c4420af70b5a2$export$5ed3e1bb3b04fc02;
module.exports["ProjectsLogo"] = $a40c4420af70b5a2$export$aeefab651bcf2338;
module.exports["RovoDevIcon"] = $a40c4420af70b5a2$export$8b784b3227531b3e;
module.exports["RovoDevLogo"] = $a40c4420af70b5a2$export$f0750468d67c6902;
module.exports["RovoDevAgentIcon"] = $a40c4420af70b5a2$export$813cff80931d9dbf;
module.exports["RovoDevAgentLogo"] = $a40c4420af70b5a2$export$409b7a5b7f180eba;
module.exports["JiraCodingAgentIcon"] = $a40c4420af70b5a2$export$b12fec207e8537a8;
module.exports["SearchIcon"] = $a40c4420af70b5a2$export$82eafebb825fc23f;
module.exports["SearchLogo"] = $a40c4420af70b5a2$export$e4c5487c9a8ae3b1;
module.exports["StudioIcon"] = $a40c4420af70b5a2$export$290a0f24614cde9f;
module.exports["StudioLogo"] = $a40c4420af70b5a2$export$8aceb78c659789b6;
module.exports["TalentIcon"] = $a40c4420af70b5a2$export$4b05688514531169;
module.exports["TalentLogo"] = $a40c4420af70b5a2$export$4f6453e012279f89;
module.exports["TeamsIcon"] = $a40c4420af70b5a2$export$1bcbc9c337da86da;
module.exports["TeamsLogo"] = $a40c4420af70b5a2$export$9b1a0a0c574cec2a;
module.exports["BambooIcon"] = $a40c4420af70b5a2$export$e812398311cab9a3;
module.exports["BambooLogo"] = $a40c4420af70b5a2$export$765f5afcc1a5a7e3;
module.exports["BitbucketDataCenterIcon"] = $a40c4420af70b5a2$export$d3ab16bbf4f954ee;
module.exports["BitbucketDataCenterLogo"] = $a40c4420af70b5a2$export$36044946916e84a0;
module.exports["ConfluenceDataCenterIcon"] = $a40c4420af70b5a2$export$53305f1f2855d3be;
module.exports["ConfluenceDataCenterLogo"] = $a40c4420af70b5a2$export$5e06396bce773a3;
module.exports["CrowdIcon"] = $a40c4420af70b5a2$export$eaf73f391f7103bd;
module.exports["CrowdLogo"] = $a40c4420af70b5a2$export$6128b385660fd3c6;
module.exports["JiraDataCenterIcon"] = $a40c4420af70b5a2$export$f8455b5667a3ee0c;
module.exports["JiraDataCenterLogo"] = $a40c4420af70b5a2$export$eb152ab3801b2ae3;
module.exports["JiraServiceManagementDataCenterIcon"] = $a40c4420af70b5a2$export$65fae0eaf343f2ca;
module.exports["JiraServiceManagementDataCenterLogo"] = $a40c4420af70b5a2$export$fffc0d480fb1ebf1;
module.exports["AtlassianAdministrationIcon"] = $a40c4420af70b5a2$export$74517ed253186308;
module.exports["AtlassianAdministrationLogo"] = $a40c4420af70b5a2$export$833abe6c2ce5ebfd;
module.exports["AtlassianAdminIcon"] = $a40c4420af70b5a2$export$84109e099492cb5f;
module.exports["AtlassianAdminLogo"] = $a40c4420af70b5a2$export$f845d9b9254f0541;
module.exports["AtlassianAnalyticsIcon"] = $a40c4420af70b5a2$export$c42ad8a0b925c762;
module.exports["AtlassianAnalyticsLogo"] = $a40c4420af70b5a2$export$e6470bfc39010cc4;
module.exports["BitbucketIcon"] = $a40c4420af70b5a2$export$5fc1066e677788d4;
module.exports["BitbucketLogo"] = $a40c4420af70b5a2$export$bd40525f5333524b;
module.exports["CompassIcon"] = $a40c4420af70b5a2$export$f7857fe64d7161d9;
module.exports["CompassLogo"] = $a40c4420af70b5a2$export$eb7d748e4f9c9676;
module.exports["DxIcon"] = $a40c4420af70b5a2$export$9951d02c2d848122;
module.exports["ConfluenceIcon"] = $a40c4420af70b5a2$export$68f3db7f6af48bcb;
module.exports["ConfluenceLogo"] = $a40c4420af70b5a2$export$1b2e4fe6ef471556;
module.exports["AlignIcon"] = $a40c4420af70b5a2$export$70a0c2f5862937b6;
module.exports["AlignLogo"] = $a40c4420af70b5a2$export$1b8596b4b0ef673b;
module.exports["JiraAlignIcon"] = $a40c4420af70b5a2$export$407687b2dd89cc68;
module.exports["JiraAlignLogo"] = $a40c4420af70b5a2$export$ee11e928d3d045fd;
module.exports["JiraIcon"] = $a40c4420af70b5a2$export$c4b5b1f965d8b3eb;
module.exports["JiraLogo"] = $a40c4420af70b5a2$export$17d3acb0b4379d02;
module.exports["JiraProductDiscoveryIcon"] = $a40c4420af70b5a2$export$21bfbeb62fdcce8d;
module.exports["JiraProductDiscoveryLogo"] = $a40c4420af70b5a2$export$c49a2b642fe9eef4;
module.exports["JiraServiceManagementIcon"] = $a40c4420af70b5a2$export$3c6158790f5e01c4;
module.exports["JiraServiceManagementLogo"] = $a40c4420af70b5a2$export$dabef2be6cd28c20;
module.exports["LoomIcon"] = $a40c4420af70b5a2$export$8d789f76fde3e05;
module.exports["LoomLogo"] = $a40c4420af70b5a2$export$94e206806e36c2ec;
module.exports["LoomAttributionIcon"] = $a40c4420af70b5a2$export$1bf47cdade1a9fcb;
module.exports["LoomAttributionLogo"] = $a40c4420af70b5a2$export$6e87ce8d41eda665;
module.exports["LoomBlurpleLogo"] = $a40c4420af70b5a2$export$e84e925618e0e5bc;
module.exports["LoomBlurpleIcon"] = $a40c4420af70b5a2$export$1940ba72c868b663;
module.exports["OpsgenieIcon"] = $a40c4420af70b5a2$export$eeccc49dc7a12d9f;
module.exports["OpsgenieLogo"] = $a40c4420af70b5a2$export$a1c6484cdecc2c4b;
module.exports["StatuspageIcon"] = $a40c4420af70b5a2$export$f3f5aa321d88adf9;
module.exports["StatuspageLogo"] = $a40c4420af70b5a2$export$bb4ae5b41b43be04;
module.exports["TrelloIcon"] = $a40c4420af70b5a2$export$4384da9b8b140bf4;
module.exports["TrelloLogo"] = $a40c4420af70b5a2$export$60e26212f3b61a28;
module.exports["RovoIcon"] = $a40c4420af70b5a2$export$e23ae35269442b4f;
module.exports["RovoLogo"] = $a40c4420af70b5a2$export$a0f6cb8061290bbb;
module.exports["GuardIcon"] = $a40c4420af70b5a2$export$3f95fcfdc25a741d;
module.exports["GuardLogo"] = $a40c4420af70b5a2$export$a4a891d202775deb;
module.exports["FocusIcon"] = $a40c4420af70b5a2$export$1e02e7298035a77c;
module.exports["FocusLogo"] = $a40c4420af70b5a2$export$33908560ea1b226d;
module.exports["CompanyHubIcon"] = $a40c4420af70b5a2$export$5ef3f25e16249826;
module.exports["CompanyHubLogo"] = $a40c4420af70b5a2$export$1ab0976b9ea166ae;
module.exports["CustomLinkIcon"] = $a40c4420af70b5a2$export$5efe8561ca252843;
module.exports["GuardDetectIcon"] = $a40c4420af70b5a2$export$e26e48d31d71c1e1;
module.exports["GuardDetectLogo"] = $a40c4420af70b5a2$export$bf5ca9fb70f56bb5;
module.exports["MoreAtlassianAppsIcon"] = $a40c4420af70b5a2$export$518f48548316ec87;

});

parcelRegister("ldJ1U", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $21feb461db975f8c$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z"/>
</svg>
`;
const $21feb461db975f8c$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z"/>
</svg>
`;
const $21feb461db975f8c$export$c4b5b1f965d8b3eb = (0, $gtMdU.isReactCompilerActivePlatform)() ? function JiraIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Jira" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $21feb461db975f8c$var$svg,
            customThemeSvg: $21feb461db975f8c$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function JiraIcon({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Jira', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $21feb461db975f8c$var$svg,
        customThemeSvg: $21feb461db975f8c$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["JiraIcon"] = $21feb461db975f8c$export$c4b5b1f965d8b3eb;

});

parcelRegister("lb2PL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $c420f5a156d6b7cf$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
const $c420f5a156d6b7cf$export$8d789f76fde3e05 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoomIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: size, appearance: t1, label: t2, testId: testId } = t0;
    const appearance = t1 === undefined ? "brand" : t1;
    const label = t2 === undefined ? "Loom" : t2;
    let t3;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
            svg: $c420f5a156d6b7cf$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function LoomIcon({ size: size, appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aR3ec.IconWrapper), {
        svg: $c420f5a156d6b7cf$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["LoomIcon"] = $c420f5a156d6b7cf$export$8d789f76fde3e05;

});

parcelRegister("aK5FI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $2JKQ0 = parcelRequire("2JKQ0");


var $ihy5X = parcelRequire("ihy5X");


var $kejsE = parcelRequire("kejsE");

const $8fd76ff07b0c96a1$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
    </svg>`;
};
const $8fd76ff07b0c96a1$export$c4b5b1f965d8b3eb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, textColor: t3, iconColor: t4 } = t0;
    const label = t1 === undefined ? "Jira" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const textColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t3;
    const iconColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $8fd76ff07b0c96a1$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            svg: t5,
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Jira', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        svg: $8fd76ff07b0c96a1$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};
module.exports["JiraIcon"] = $8fd76ff07b0c96a1$export$c4b5b1f965d8b3eb;

});

parcelRegister("lfEjj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $2JKQ0 = parcelRequire("2JKQ0");


var $ihy5X = parcelRequire("ihy5X");


var $lH46a = parcelRequire("lH46a");

const $378a5be590bf054a$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $lH46a.getColorsForLoom)(appearance, colorMode);
    return `<svg
    fill="none"
    height="32"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    aria-hidden="true"
  >
    <path
      d="M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884"
      fill="${colors.iconColor}"
    />
  </svg>`;
};
const $378a5be590bf054a$export$8d789f76fde3e05 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Loom" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $378a5be590bf054a$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            svg: t5,
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Loom', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        svg: $378a5be590bf054a$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};
module.exports["LoomIcon"] = $378a5be590bf054a$export$8d789f76fde3e05;

});

parcelRegister("iXV0W", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $2JKQ0 = parcelRequire("2JKQ0");


var $ihy5X = parcelRequire("ihy5X");


var $kejsE = parcelRequire("kejsE");

const $fd80450b438ac719$var$svg = ({ appearance: appearance }, colorMode)=>{
    let colors = (0, $kejsE.getColorsFromAppearance)(appearance ? appearance : 'brand', colorMode);
    return `<svg viewBox="0 0 32 32" focusable="false" aria-hidden="true" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g fill="${colors.iconColor}">
      <path d="M16 28.532c-6.656 0-12.068-5.412-12.068-12.068S9.344 4.396 16 4.396v1.921c-5.597 0-10.146 4.549-10.146 10.146S10.403 26.609 16 26.609zm0 0v-1.921c5.597 0 10.146-4.549 10.146-10.146h1.921c0 6.656-5.412 12.068-12.068 12.068zm12.068-12.068h-1.921c0-5.597-4.549-10.146-10.146-10.146V4.397c6.656 0 12.068 5.412 12.068 12.068zm-6.928 3.695c-1.28-.251-2.292-.706-3.973-1.467-.464-.204-.974-.436-1.559-.696a59 59 0 0 0-1.003-.436c-2.534-1.123-3.926-1.736-5.634-1.736-1.198 0-2.098.325-2.6.937a1.72 1.72 0 0 0-.38 1.448l-1.885.362a3.67 3.67 0 0 1 .78-3.035c.613-.743 1.82-1.634 4.085-1.634 2.116 0 3.824.761 6.414 1.903.316.14.641.288.994.436.594.26 1.114.492 1.578.706 1.606.724 2.488 1.123 3.555 1.327l-.371 1.885Zm1.877.185c-.64 0-1.253-.056-1.875-.185l.371-1.885c.502.102.994.149 1.504.149 1.188 0 2.089-.298 2.609-.864s.539-1.253.51-1.615l1.913-.167c.102 1.169-.251 2.265-1.003 3.082-.622.677-1.82 1.485-4.029 1.485M16 28.532v-1.921c2.757 0 4.4-2.813 4.4-7.52s-1.67-8.652-5.096-12.3l1.402-1.318c3.778 4.02 5.616 8.476 5.616 13.618 0 5.821-2.423 9.441-6.322 9.441m-.001 0c-4.15 0-6.526-3.379-6.526-9.273 0-6.879 3.008-10.722 5.82-13.776l1.412 1.299c-3.277 3.565-5.31 6.888-5.31 12.476 0 6.08 2.506 7.352 4.604 7.352z"/>
      <path d="M10.857 17.467a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494m10.385 3.871a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494M15.998 7.96a2.247 2.247 0 1 0 0-4.493 2.247 2.247 0 0 0 0 4.494Z"/>
    </g>
  </svg>`;
};
const $fd80450b438ac719$export$9d0b19639662f94b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { appearance: appearance, label: t1, size: t2, testId: testId } = t0;
    const label = t1 === undefined ? "Atlas" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t3;
    if ($[0] !== appearance || $[1] !== colorMode) {
        t3 = $fd80450b438ac719$var$svg({
            appearance: appearance
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== appearance || $[4] !== label || $[5] !== size || $[6] !== t3 || $[7] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            svg: t3,
            size: size,
            testId: testId
        });
        $[3] = appearance;
        $[4] = label;
        $[5] = size;
        $[6] = t3;
        $[7] = testId;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ appearance: appearance, label: label = 'Atlas', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        svg: $fd80450b438ac719$var$svg({
            appearance: appearance
        }, colorMode),
        size: size,
        testId: testId
    });
};
module.exports["AtlasIcon"] = $fd80450b438ac719$export$9d0b19639662f94b;

});

parcelRegister("9opDp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $2JKQ0 = parcelRequire("2JKQ0");


var $ihy5X = parcelRequire("ihy5X");


var $cPYuK = parcelRequire("cPYuK");

const $1f3cbd888554cf9f$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $2JKQ0.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $2JKQ0.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cPYuK.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <linearGradient
        id="${id}"
        gradientUnits="userSpaceOnUse"
        x1="13.9485"
        x2="20.7792"
        y1="20.2388"
        y2="11.8277"
      >
        <stop offset="0" stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} />
        <stop offset="100%" stop-color="${colors.iconGradientStop}" />
      </linearGradient>
      <path
        d="m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z"
        fill="url(#${id})"
      />
      <path
      fill="${colors.iconColor}"
      d="m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z"
      />
    </svg>`;
};
const $1f3cbd888554cf9f$export$7330b9fc5718fd30 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Jira Work Management" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const id = (0, $6JrSr.useId)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== id) {
        t5 = $1f3cbd888554cf9f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = id;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            svg: t5,
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Jira Work Management', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const id = (0, $6JrSr.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        svg: $1f3cbd888554cf9f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};
module.exports["JiraWorkManagementIcon"] = $1f3cbd888554cf9f$export$7330b9fc5718fd30;

});

parcelRegister("NlHoa", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $2JKQ0 = parcelRequire("2JKQ0");


var $ihy5X = parcelRequire("ihy5X");


var $kejsE = parcelRequire("kejsE");

const $441e7b8270821bd5$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
    </svg>`;
};
const $441e7b8270821bd5$export$8a485e2e7ed91e8f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, iconColor: t3, textColor: t4, testId: testId } = t0;
    const label = t1 === undefined ? "Atlassian" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $441e7b8270821bd5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            svg: t5,
            iconColor: iconColor,
            textColor: textColor,
            size: size,
            testId: testId
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, $2JKQ0.defaultLogoParams).size, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        svg: $441e7b8270821bd5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};
module.exports["AtlassianIcon"] = $441e7b8270821bd5$export$8a485e2e7ed91e8f;

});

parcelRegister("kbI17", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $2JKQ0 = parcelRequire("2JKQ0");


var $ihy5X = parcelRequire("ihy5X");


var $kejsE = parcelRequire("kejsE");

const $aa58b540968c0476$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198 32" focusable="false" aria-hidden="true" height="32" fill="none">
      <path fill=${colors.iconColor} d="M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"/>
      <path fill=${colors.atlassianLogoTextColor} d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354"/>
    </svg>`;
};
const $aa58b540968c0476$export$765cacec8b0843f3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Atlassian" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $aa58b540968c0476$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            svg: t5,
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        svg: $aa58b540968c0476$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};
module.exports["AtlassianLogo"] = $aa58b540968c0476$export$765cacec8b0843f3;

});

parcelRegister("llfZq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $2JKQ0 = parcelRequire("2JKQ0");


var $ihy5X = parcelRequire("ihy5X");


var $cPYuK = parcelRequire("cPYuK");

const $13ca3630b4897341$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $2JKQ0.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $2JKQ0.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cPYuK.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
    <defs>
      <linearGradient x1="108.695%" x2="12.439%" y1="-14.936%" y2="45.215%" id="${id}-1">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
      <linearGradient x1="0%" x2="91.029%" y1="118.55%" y2="63.971%" id="${id}-2">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g stroke="none" stroke-width="1" fill-rule="nonzero">
      <path fill="${colors.iconColor}" d="M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z" />
      <path fill="url(#${id}-1" d="M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z" />
      <path fill="url(#${id}-2" d="M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z" />
    </g>
  </svg>`;
};
const $13ca3630b4897341$export$c3835feba2a66e67 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Jira Software" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const id = (0, $6JrSr.useId)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== id) {
        t5 = $13ca3630b4897341$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = id;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            svg: t5,
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Jira Software', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const id = (0, $6JrSr.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        svg: $13ca3630b4897341$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};
module.exports["JiraSoftwareIcon"] = $13ca3630b4897341$export$c3835feba2a66e67;

});

parcelRegister("kejsE", function(module, exports) {
const $f7c26c357aa6be32$export$bbacc3980e0f3029 = (appearance, colorMode)=>{
    let iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
module.exports["getColorsFromAppearance"] = $f7c26c357aa6be32$export$bbacc3980e0f3029;

});

parcelRegister("aR3ec", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $ixfCV = parcelRequire("ixfCV");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $1f4e40c711db0c72$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
const $1f4e40c711db0c72$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
const $1f4e40c711db0c72$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
const $1f4e40c711db0c72$export$be58b4326e23250f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IconWrapper(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { size: t1, label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: t2, iconColor: customIconColor, isAssets: t3, type: t4 } = t0;
    const size = t1 === undefined ? "20" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const isAssets = t3 === undefined ? false : t3;
    const type = t4 === undefined ? "tile" : t4;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const t5 = customIconColor || "initial";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            "--themed-icon-color": t5
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const t7 = t6;
    const t8 = label ? label : undefined;
    const t9 = label ? "img" : undefined;
    const t10 = label === "" ? true : undefined;
    const t11 = isCustomThemed ? customThemeSvg : svg;
    let t12;
    if ($[2] !== t11) {
        t12 = {
            __html: t11
        };
        $[2] = t11;
        $[3] = t12;
    } else t12 = $[3];
    const t13 = $1f4e40c711db0c72$var$sizeMap[size];
    const t14 = colorMode === "dark" ? $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$dataCenterLightAppearanceMap[appearance];
    const t15 = type === "rovo" ? colorMode === "dark" ? $1f4e40c711db0c72$var$rovoDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$rovoLightAppearanceMap[appearance] : colorMode === "dark" ? $1f4e40c711db0c72$var$cloudDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$cloudLightAppearanceMap[appearance];
    let t16;
    if ($[4] !== appearance || $[5] !== isAssets || $[6] !== t13 || $[7] !== t14 || $[8] !== t15) {
        t16 = (0, $hekY6.default)([
            $1f4e40c711db0c72$var$styles.root,
            t13,
            t14,
            t15,
            isAssets && appearance === "brand" && ((0, $ixfCV.fg)("assets-platform-branding") || (0, $ixfCV.fg)("assets-platform-branding-with-confluence")) && $1f4e40c711db0c72$var$styles.TEMP_assets
        ]);
        $[4] = appearance;
        $[5] = isAssets;
        $[6] = t13;
        $[7] = t14;
        $[8] = t15;
        $[9] = t16;
    } else t16 = $[9];
    let t17;
    if ($[10] !== t10 || $[11] !== t12 || $[12] !== t16 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9 || $[16] !== testId) {
        t17 = /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": testId,
            style: t7,
            "aria-label": t8,
            role: t9,
            "aria-hidden": t10,
            dangerouslySetInnerHTML: t12,
            className: t16
        });
        $[10] = t10;
        $[11] = t12;
        $[12] = t16;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = t17;
    } else t17 = $[17];
    return t17;
} : function IconWrapper({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $hekY6.default)([
            $1f4e40c711db0c72$var$styles.root,
            $1f4e40c711db0c72$var$sizeMap[size],
            colorMode === 'dark' ? $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $1f4e40c711db0c72$var$rovoDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $1f4e40c711db0c72$var$cloudDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $ixfCV.fg)('assets-platform-branding') || (0, $ixfCV.fg)('assets-platform-branding-with-confluence')) && $1f4e40c711db0c72$var$styles.TEMP_assets
        ])
    });
};
module.exports["IconWrapper"] = $1f4e40c711db0c72$export$be58b4326e23250f;

});

parcelRegister("2JKQ0", function(module, exports) {
const $88abaf6247c4a414$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
const $88abaf6247c4a414$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
};
module.exports["defaultLogoParams"] = $88abaf6247c4a414$export$438460117ae6b7ee;
module.exports["legacyDefaultLogoParams"] = $88abaf6247c4a414$export$793fba32aed8942a;

});

parcelRegister("ihy5X", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $063b37f584f47387$var$CSS_VAR_COLOR = '--logo-color';
const $063b37f584f47387$var$CSS_VAR_FILL = '--logo-fill';
const $063b37f584f47387$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ const $063b37f584f47387$var$Wrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    let appearance;
    let iconColor;
    let label;
    let rest;
    let size;
    let svg;
    let textColor;
    let userDefinedTestId;
    if ($[0] !== t0) {
        ({ label: label, svg: svg, size: size, appearance: appearance, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest } = t0);
        $[0] = t0;
        $[1] = appearance;
        $[2] = iconColor;
        $[3] = label;
        $[4] = rest;
        $[5] = size;
        $[6] = svg;
        $[7] = textColor;
        $[8] = userDefinedTestId;
    } else {
        appearance = $[1];
        iconColor = $[2];
        label = $[3];
        rest = $[4];
        size = $[5];
        svg = $[6];
        textColor = $[7];
        userDefinedTestId = $[8];
    }
    const shouldApplyStopColor = appearance === undefined;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    let t1;
    if ($[9] !== iconColor || $[10] !== textColor) {
        t1 = {
            [$063b37f584f47387$var$CSS_VAR_COLOR]: iconColor,
            [$063b37f584f47387$var$CSS_VAR_FILL]: textColor
        };
        $[9] = iconColor;
        $[10] = textColor;
        $[11] = t1;
    } else t1 = $[11];
    const t2 = t1;
    const t3 = label ? label : undefined;
    const t4 = label ? "img" : undefined;
    let t5;
    if ($[12] !== svg) {
        t5 = {
            __html: svg
        };
        $[12] = svg;
        $[13] = t5;
    } else t5 = $[13];
    const t6 = shouldApplyStopColor && $063b37f584f47387$var$styles.stop;
    const t7 = size && $063b37f584f47387$var$styles[size];
    let t8;
    if ($[14] !== t6 || $[15] !== t7) {
        t8 = (0, $hekY6.default)([
            $063b37f584f47387$var$styles.root,
            t6,
            t7
        ]);
        $[14] = t6;
        $[15] = t7;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== rest || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t8 || $[23] !== testId) {
        t9 = /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": testId,
            style: t2,
            "aria-label": t3,
            role: t4,
            dangerouslySetInnerHTML: t5,
            ...rest,
            className: t8
        });
        $[17] = rest;
        $[18] = t2;
        $[19] = t3;
        $[20] = t4;
        $[21] = t5;
        $[22] = t8;
        $[23] = testId;
        $[24] = t9;
    } else t9 = $[24];
    return t9;
} : ({ label: label, svg: svg, size: size, appearance: appearance, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest })=>{
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    const shouldApplyStopColor = appearance === undefined;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": testId,
        style: {
            [$063b37f584f47387$var$CSS_VAR_COLOR]: iconColor,
            [$063b37f584f47387$var$CSS_VAR_FILL]: textColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        },
        ...rest,
        className: (0, $hekY6.default)([
            $063b37f584f47387$var$styles.root,
            shouldApplyStopColor && $063b37f584f47387$var$styles.stop,
            size && $063b37f584f47387$var$styles[size]
        ])
    });
};
var $063b37f584f47387$export$2e2bcd8739ae039 = $063b37f584f47387$var$Wrapper;
module.exports["default"] = $063b37f584f47387$export$2e2bcd8739ae039;

});

parcelRegister("lNhWn", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $2JKQ0 = parcelRequire("2JKQ0");


var $ihy5X = parcelRequire("ihy5X");


var $kejsE = parcelRequire("kejsE");

const $0c12e34e72b1ae63$var$svg = ({ appearance: appearance }, colorMode)=>{
    let colors = (0, $kejsE.getColorsFromAppearance)(appearance ? appearance : 'brand', colorMode);
    return `<svg viewBox="0 0 102 32" focusable="false" aria-hidden="true" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.068 27.865C5.412 27.865 0 22.453 0 15.797S5.412 3.73 12.068 3.73v1.922c-5.597 0-10.146 4.548-10.146 10.146 0 5.597 4.549 10.145 10.146 10.145z M12.068 27.865v-1.92c5.597 0 10.146-4.55 10.146-10.147h1.921c0 6.656-5.412 12.068-12.068 12.068h.001Zm12.068-12.068h-1.921c0-5.597-4.549-10.146-10.146-10.146V3.73c6.656 0 12.068 5.412 12.068 12.068zm-6.927 3.695c-1.282-.25-2.293-.705-3.974-1.466-.464-.204-.974-.436-1.559-.696a58 58 0 0 0-1.003-.436C8.14 15.77 6.747 15.158 5.04 15.158c-1.198 0-2.098.324-2.6.937a1.72 1.72 0 0 0-.38 1.448l-1.885.362a3.67 3.67 0 0 1 .78-3.035c.613-.743 1.82-1.634 4.085-1.634 2.116 0 3.824.761 6.414 1.903.316.14.641.288.994.436.594.26 1.114.492 1.578.705 1.606.724 2.488 1.124 3.555 1.328l-.371 1.884Z M19.085 19.677c-.64 0-1.253-.056-1.875-.185l.371-1.885c.502.102.994.15 1.504.15 1.188 0 2.089-.298 2.609-.864s.539-1.254.51-1.616l1.913-.167c.102 1.17-.251 2.265-1.003 3.082-.622.677-1.82 1.485-4.029 1.485 M12.068 27.865v-1.92c2.757 0 4.4-2.814 4.4-7.52 0-4.707-1.67-8.652-5.096-12.3l1.402-1.318c3.778 4.02 5.616 8.475 5.616 13.618 0 5.82-2.423 9.44-6.322 9.44 M12.067 27.866c-4.15 0-6.526-3.379-6.526-9.274 0-6.878 3.008-10.722 5.82-13.776l1.412 1.3c-3.277 3.564-5.31 6.888-5.31 12.476 0 6.08 2.506 7.352 4.604 7.352v1.921Z" fill="${colors.iconColor}"/>
    <path d="M6.925 16.8a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494m10.385 3.872a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494M12.066 7.294a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494" fill="${colors.iconColor}"/>
    <path d="M101.019 21.163c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.89-1.84-3.803-2.545-3.404-.828-4.845-2.147-4.845-4.661 0-2.668 2.054-4.294 5.55-4.294 1.994 0 3.803.491 4.938 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.675-2.975 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.122 2.086 5.122 4.754m-25.873-3.496c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.08 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.638v15.333zm-12.784-.03c-.214.061-.674.122-1.349.122-2.514 0-4.11-1.196-4.11-4.017V3.591h2.638V21.1c0 1.38.92 1.871 2.055 1.871.276 0 .46 0 .767-.03v2.36ZM58.12 20.58c0 1.35.798 2.27 2.423 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.779.245c-3.28 0-4.876-1.932-4.876-4.784v-8.188h-2.483V10h2.483V6.75h2.577V10h4.078v2.453h-4.078v8.127Zm-14.675.736c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.81.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369" fill="${colors.textColor}"/>
  </svg>`;
};
const $0c12e34e72b1ae63$export$e388b783bff06f6c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { appearance: appearance, label: t1, size: t2, testId: testId } = t0;
    const label = t1 === undefined ? "Atlas" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t3;
    if ($[0] !== appearance || $[1] !== colorMode) {
        t3 = $0c12e34e72b1ae63$var$svg({
            appearance: appearance
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== appearance || $[4] !== label || $[5] !== size || $[6] !== t3 || $[7] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            size: size,
            svg: t3,
            testId: testId
        });
        $[3] = appearance;
        $[4] = label;
        $[5] = size;
        $[6] = t3;
        $[7] = testId;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ appearance: appearance, label: label = 'Atlas', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        size: size,
        svg: $0c12e34e72b1ae63$var$svg({
            appearance: appearance
        }, colorMode),
        testId: testId
    });
};
module.exports["AtlasLogo"] = $0c12e34e72b1ae63$export$e388b783bff06f6c;

});

parcelRegister("3FmCf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $2JKQ0 = parcelRequire("2JKQ0");


var $ihy5X = parcelRequire("ihy5X");


var $kejsE = parcelRequire("kejsE");

const $a37ca3e09294439a$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
    <path fill="${colors.iconColor}" d="M27.545 24.817 16.96 3.647c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.126-2.167 8 0 4.002 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.816c-.834-1.25-1.084-1.334-1.292-1.334s-.333.084-.708.834L4.875 24.9c-.167.334-.208.459-.208.626 0 .333.291.666.916.666h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.875.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
  </svg>
  `;
};
const $a37ca3e09294439a$export$94c87d39a54a1894 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, textColor: t3, iconColor: t4 } = t0;
    const label = t1 === undefined ? "Atlassian Marketplace" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const textColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t3;
    const iconColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $a37ca3e09294439a$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            svg: t5,
            iconColor: iconColor,
            label: label,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Atlassian Marketplace', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        svg: $a37ca3e09294439a$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};
module.exports["AtlassianMarketplaceIcon"] = $a37ca3e09294439a$export$94c87d39a54a1894;

});

parcelRegister("2CnS6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $2JKQ0 = parcelRequire("2JKQ0");


var $ihy5X = parcelRequire("ihy5X");


var $kejsE = parcelRequire("kejsE");

const $529c38641750b44c$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 377 32" focusable="false" aria-hidden="true">
      <path
        d="M369.828 12.524c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.943 8.004-7.943 1.38 0 2.453.184 3.649.736v2.454c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.514-5.612 5.489s1.656 5.49 5.673 5.49c1.564 0 2.545-.215 3.496-.553m-26.118-4.906c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.638v15.333zm-12.783-.031c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V4.03h2.637v17.51c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-11.153-7.635c0-3.68-1.472-5.52-4.202-5.52-2.361 0-4.477 1.502-4.477 4.906v1.227c0 3.404 1.932 4.907 4.171 4.907 2.974 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.239 0-3.956-1.012-4.876-3.005v8.678h-2.637V10.44h2.637v2.76c.981-2.024 2.821-3.067 5.183-3.067 4.078 0 6.133 3.466 6.133 7.974 0 4.324-2.147 7.973-6.44 7.973zm-14.975-5.06c0 1.35.798 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.779.245c-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10.44h2.484V7.19h2.576v3.25h4.079v2.453h-4.079zm-13.537-8.495c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-23.82.613h-2.637V4.03H269v13.585l6.593-7.176h3.435l-7.207 7.544 7.514 7.79h-3.588L269 18.595zm-10.333-9.046v9.046h-2.576V10.44h2.576v2.699c.889-1.81 2.422-3.098 5.428-2.914V12.8c-3.374-.337-5.428.675-5.428 3.926m-17.869 1.38c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.638v15.333zm-31.445-11.009-2.76-7.483v18.492h-2.76V5.624h4.784l4.569 11.562 1.871 5.55 1.871-5.55 4.6-11.562h4.446v20.148h-2.76V7.495l-2.361 7.268-4.447 11.01h-2.668z"
        fill="${colors.textColor}"
      />
      <path
        d="M107.447 11.267c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.807c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V10.417l1.769 4.034 6.087 11.325h5.379V5.604h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.156c0-3.54-1.841-5.167-7.149-6.3-2.902-.636-3.609-1.273-3.609-2.194 0-1.132 1.061-1.627 2.972-1.627 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.308 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3zM71.069 5.604v20.172h9.625l1.486-4.389h-6.44V5.604zm-19.039 0v4.318h5.167v15.854h4.741V9.922h5.592V5.604zm-6.866 0h-6.157L32 25.776h5.379l.99-3.398c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.698c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.604H91.17l-7.08 20.172h5.38l.99-3.398c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.114 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.094h-6.157l-7.007 20.172h5.379l.991-3.398c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.817 12.293 3.647c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.126-2.167 8 0 4.002 2.042 7.752 5.043 13.795.333.666.583.791 1.166.791h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.816c-.833-1.25-1.083-1.334-1.292-1.334s-.333.084-.708.834L.208 24.9c-.166.334-.208.459-.208.626 0 .333.292.666.917.666h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.875.333-2.917 0-2.917-1.292-5.751-2.292-7.251"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $529c38641750b44c$export$32e7eace0c9d6a57 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, textColor: t3, iconColor: t4 } = t0;
    const label = t1 === undefined ? "Atlassian Marketplace" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const textColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t3;
    const iconColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $529c38641750b44c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            iconColor: iconColor,
            label: label,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Atlassian Marketplace', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $529c38641750b44c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};
module.exports["AtlassianMarketplaceLogo"] = $529c38641750b44c$export$32e7eace0c9d6a57;

});

parcelRegister("h47pR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $2JKQ0 = parcelRequire("2JKQ0");


var $ihy5X = parcelRequire("ihy5X");


var $kejsE = parcelRequire("kejsE");

const $f3b1fdf67c2de2b4$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg
      fill="none"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.126-2.167 8.001 0 4 2.042 7.751 5.042 13.794.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.084-.708.834L4.875 24.462c-.167.333-.208.458-.208.625 0 .333.291.666.916.666h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.875.334-2.917 0-2.917-1.292-5.751-2.292-7.251"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $f3b1fdf67c2de2b4$export$a825993f361832f7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, label: t1, size: t2, testId: testId, textColor: t3, iconColor: t4 } = t0;
    const label = t1 === undefined ? "Atlassian Access" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const textColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t3;
    const iconColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor) {
        t5 = $f3b1fdf67c2de2b4$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== appearance || $[5] !== iconColor || $[6] !== label || $[7] !== size || $[8] !== t5 || $[9] !== testId || $[10] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            svg: t5,
            iconColor: iconColor,
            label: label,
            size: size,
            testId: testId,
            textColor: textColor
        });
        $[4] = appearance;
        $[5] = iconColor;
        $[6] = label;
        $[7] = size;
        $[8] = t5;
        $[9] = testId;
        $[10] = textColor;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ appearance: appearance, label: label = 'Atlassian Access', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        svg: $f3b1fdf67c2de2b4$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};
module.exports["AtlassianAccessIcon"] = $f3b1fdf67c2de2b4$export$a825993f361832f7;

});

parcelRegister("6aKgW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $2JKQ0 = parcelRequire("2JKQ0");


var $ihy5X = parcelRequire("ihy5X");


var $kejsE = parcelRequire("kejsE");

const $d5106a8579090157$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode);
    return `<svg
      fill="none"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 299 32"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M298.505 21.163c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754m-13.626 0c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.828-4.845-2.147-4.845-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.802.491 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.675-2.975 1.87 0 1.074.736 1.749 3.558 2.423 3.404.828 5.121 2.086 5.121 4.754m-20.467-9.078c-2.791 0-4.202 1.81-4.478 4.478h8.556c-.153-2.852-1.441-4.478-4.078-4.478M270.3 24.72c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.147v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.943 8.004-7.943 1.38 0 2.453.184 3.649.736v2.454c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.514-5.612 5.489s1.656 5.49 5.673 5.49c1.564 0 2.546-.215 3.496-.553m-13.836 0v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.943 8.004-7.943 1.38 0 2.453.184 3.649.736v2.454c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.514-5.612 5.489s1.656 5.49 5.673 5.49c1.564 0 2.546-.215 3.496-.553m-22.45-1.257c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369"
        fill="${colors.textColor}"
      />
      <path
        d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.337h5.379l.99-3.398c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.172h5.38l.99-3.398c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.172h5.379l.991-3.398c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.126-2.167 8.001 0 4 2.042 7.751 5.043 13.794.333.666.583.791 1.166.791h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.084-.708.834L.208 24.462c-.166.333-.208.458-.208.625 0 .333.292.666.917.666h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.875.333-2.917 0-2.917-1.292-5.751-2.292-7.251"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $d5106a8579090157$export$5aa23cd4d8596f56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, label: t1, size: t2, testId: testId, textColor: t3, iconColor: t4 } = t0;
    const label = t1 === undefined ? "Atlassian Access" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const textColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t3;
    const iconColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== textColor) {
        t5 = $d5106a8579090157$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = textColor;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== appearance || $[6] !== iconColor || $[7] !== label || $[8] !== size || $[9] !== t5 || $[10] !== testId || $[11] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            iconColor: iconColor,
            label: label,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[5] = appearance;
        $[6] = iconColor;
        $[7] = label;
        $[8] = size;
        $[9] = t5;
        $[10] = testId;
        $[11] = textColor;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ appearance: appearance, label: label = 'Atlassian Access', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $d5106a8579090157$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};
module.exports["AtlassianAccessLogo"] = $d5106a8579090157$export$5aa23cd4d8596f56;

});

parcelRegister("dnlpr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $2JKQ0 = parcelRequire("2JKQ0");


var $ihy5X = parcelRequire("ihy5X");


var $cPYuK = parcelRequire("cPYuK");

const $bd0fead550960ba8$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $2JKQ0.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $2JKQ0.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cPYuK.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
  <svg
  fill="none"
  height="32"
  viewBox="0 0 303 32"
  xmlns="http://www.w3.org/2000/svg"
>
  <linearGradient
    id="${id}"
    gradientUnits="userSpaceOnUse"
    x1="7.94848"
    x2="14.7792"
    y1="19.536"
    y2="11.1249"
  >
    <stop offset="0" stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} />
    <stop offset="100%" stop-color="${colors.iconGradientStop}" />
  </linearGradient>
  <path
    d="m12.3893 6.29721-3.42568 13.18669c4.35918 1.2052 7.83828-.3558 9.17088-5.4802l1.9988-7.69729z"
    fill="url(#${id})"
  />
  <path fill="${colors.iconColor}" d="m7.75657 24.1237 3.42573-13.1866c-4.3623-1.19602-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z" />
  <g fill="${colors.textColor}">
    <path
      clip-rule="evenodd"
      d="m122.757 5v19.1237h2.379v-6.305l6.085 6.305h3.234l-6.776-6.8448 6.499-6.6485h-3.095l-5.947 6.3296v-11.96zm-84.0053.55058c-.2088-.0757-.4319-.1066-.654-.09058-.222-.0155-.4448.01575-.6533.09164-.2086.07589-.398.19465-.5553.34821-.1574.15356-.2791.33835-.3569.54183s-.1098.4209-.0939.63752c0 .42944.1748.84129.486 1.14495s.7333.47425 1.1734.47425.8622-.17059 1.1734-.47425.4861-.71551.4861-1.14495c.0164-.21674-.0153-.43438-.0929-.6381s-.1993-.38872-.3568-.5424c-.1574-.15367-.347-.27241-.5558-.34812zm.5089 5.07982h-2.3792v13.4933h2.3792zm-5.6979-4.22587h-2.4891l.0094 12.49357c0 1.7695-.726 2.9962-2.8286 2.9962-.88.0065-1.7534-.1496-2.574-.46v2.349c.9621.3182 1.9731.4727 2.9889.457 3.4288 0 4.8934-2.2387 4.8934-5.5047zm11.6158 17.71917h-2.3225v-13.4933h2.3225v2.3736c.8015-1.5916 2.1843-2.7232 4.8966-2.5637v2.2693c-3.0423-.3067-4.8966.5919-4.8966 3.4531zm11.3678.2791c2.1309 0 3.7903-.9169 4.6734-2.6987l.0032 2.4196h2.3791v-13.4933h-2.3791v2.3828c-.8329-1.7541-2.3823-2.6435-4.4-2.6435-3.872 0-5.808 3.2108-5.808 7.0166 0 3.9682 1.8543 7.0165 5.5314 7.0165zm4.6734-6.4768c0 2.9961-1.9077 4.3179-4.0385 4.3179-2.4609 0-3.7872-1.6192-3.7966-4.8576 0-3.1311 1.3829-4.8576 4.0637-4.8576 2.0303 0 3.7714 1.3217 3.7714 4.3178zm8.6023-11.52147h2.5709l4.7143 15.43457 5.1731-15.43457h2.9291l5.1732 15.43457 4.73-15.43457h2.4891l-5.7105 17.71917h-3.1806l-5.0286-15.1401-5.0285 15.1401h-3.0989zm34.376 3.96517c-4.148 0-6.5808 2.941-6.5808 6.989s2.4608 7.0533 6.5808 7.0533c4.121 0 6.528-3.0053 6.528-7.0533s-2.379-6.989-6.528-6.989zm0 11.8742c-2.957 0-4.2582-2.3215-4.2582-4.8852h.0031c0-2.5638 1.3231-4.83 4.2551-4.83 2.933 0 4.205 2.2662 4.205 4.83 0 2.5637-1.247 4.8852-4.205 4.8852zm11.617 1.8798h-2.323v-13.4933h2.323v2.3736c.801-1.5916 2.184-2.7232 4.896-2.5637v2.2693c-3.042-.3067-4.896.5919-4.896 3.4531zm28.734-16.2533v16.2533h-2.492v-17.71917h4.315l4.121 10.17217 1.687 4.8852 1.688-4.8852 4.149-10.17217h4.01v17.71917h-2.489v-16.07543l-2.131 6.39703-4.007 9.6784h-2.408l-3.953-9.6784zm26.165 16.5324c2.131 0 3.79-.9169 4.673-2.6987l.003 2.4196h2.38v-13.4933h-2.38v2.3828c-.833-1.7541-2.382-2.6435-4.4-2.6435-3.872 0-5.808 3.2108-5.808 7.0166 0 3.9682 1.855 7.0165 5.532 7.0165zm4.673-6.4768c0 2.9961-1.907 4.3179-4.038 4.3179-2.461 0-3.787-1.6192-3.797-4.8576 0-3.1311 1.383-4.8576 4.064-4.8576 2.03 0 3.771 1.3217 3.771 4.3178zm17.729 6.1977h-2.379v-8.142c0-2.4288-.996-3.5082-3.262-3.5082-2.2 0-3.734 1.4321-3.734 4.1584v7.4918h-2.379v-13.4933h2.379v2.2141c.423-.7665 1.055-1.4041 1.826-1.8424s1.651-.6603 2.543-.6416c3.18 0 5.006 2.1467 5.006 5.8574zm8.021.2791c2.131 0 3.79-.9169 4.673-2.6987l.003 2.4196h2.379v-13.4933h-2.379v2.3828c-.833-1.7541-2.382-2.6435-4.4-2.6435-3.872 0-5.808 3.2108-5.808 7.0166 0 3.9682 1.855 7.0165 5.532 7.0165zm4.673-6.4768c0 2.9961-1.908 4.3179-4.038 4.3179-2.461 0-3.772-1.6192-3.772-4.8668 0-3.1219 1.367-4.8484 4.039-4.8484 2.03 0 3.771 1.3217 3.771 4.3178zm15.293 3.7781c-.883 1.7818-2.542 2.6987-4.673 2.6987-3.658 0-5.475-3.0391-5.475-7.0257 0-3.8058 1.908-7.0166 5.752-7.0166 2.02 0 3.567.8894 4.4 2.6435v-2.3736h2.325v12.2667c0 3.9682-1.911 6.6393-6.861 6.6393-1.672.0477-3.339-.1995-4.921-.7299v-2.2294c1.549.5193 3.173.7927 4.811.8096 3.458 0 4.646-1.8094 4.646-4.3179zm-4.035.5398c2.128 0 4.035-1.3218 4.035-4.3179v-1.0795c0-2.9961-1.741-4.3178-3.771-4.3178-2.684 0-4.067 1.7265-4.067 4.8576.013 3.2384 1.339 4.8576 3.803 4.8576zm9.127-4.8944c0 4.14 2.266 7.0533 7.439 7.0533 1.411 0 3.152-.2147 4.281-.7943v-2.1466c-1.346.477-2.767.7199-4.199.7176-3.263 0-4.784-1.4843-5.117-3.7782h10.092v-1.0518c0-4.1002-1.71-6.989-5.972-6.989-4.202 0-6.524 2.9134-6.524 6.989zm10.095-.92h-7.719v-.0154c.251-2.346 1.521-3.9437 4.038-3.9437 2.38 0 3.542 1.4352 3.681 3.9591zm16.98 7.6942h-2.379v-8.142c0-2.4288-.996-3.5082-3.265-3.5082-2.2 0-3.731 1.4321-3.731 4.1584v7.4918h-2.379v-13.4933h2.37v2.2141c.423-.7667 1.054-1.4045 1.825-1.8428.771-.4384 1.651-.6603 2.543-.6412 2.351 0 3.954 1.1592 4.646 3.2936.776-2.0792 2.627-3.2936 4.924-3.2936 3.096 0 4.812 2.0516 4.812 5.8574v7.9058h-2.379v-7.4918c.009-2.7815-.971-4.1615-3.253-4.1615-2.2 0-3.734 1.4321-3.734 4.1584zm11.865-6.7742c0 4.14 2.266 7.0533 7.439 7.0533 1.411 0 3.152-.2147 4.287-.8035v-2.1466c-1.347.4808-2.771.7269-4.205.7268-3.263 0-4.784-1.4843-5.117-3.7782h10.095v-1.0518c0-4.1002-1.713-6.989-5.972-6.989-4.205 0-6.527 2.9134-6.527 6.989zm10.095-.92h-7.716v-.0154c.258-2.346 1.515-3.9437 4.029-3.9437 2.385 0 3.548 1.4352 3.687 3.9591zm16.98 7.6942h-2.379v-8.142c0-2.4288-1.002-3.5113-3.262-3.5113-2.2 0-3.734 1.4321-3.734 4.1584v7.4949h-2.379v-13.4933h2.379v2.2141c.423-.7667 1.055-1.4045 1.826-1.8428.771-.4384 1.651-.6603 2.543-.6412 3.18 0 5.006 2.1467 5.006 5.8574zm10.287-2.3644c-.49.1102-.99.1728-1.493.1871-1.464 0-2.184-.8096-2.187-1.9964v-7.1729h3.677v-2.1467h-3.677v-2.852h-2.323v2.852h-2.241v2.1681h2.241v7.2067c0 2.5085 1.44 4.2075 4.4 4.2075.542.0028 1.082-.0695 1.603-.2147z"
      fill-rule="evenodd"
    />
  </g>
</svg>`;
};
const $bd0fead550960ba8$export$56cadce97cc7cc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Jira Work Management" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const id = (0, $6JrSr.useId)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== id || $[4] !== size || $[5] !== textColor) {
        t5 = $bd0fead550960ba8$var$svg({
            appearance: appearance,
            size: size,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = id;
        $[4] = size;
        $[5] = textColor;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== appearance || $[8] !== iconColor || $[9] !== label || $[10] !== size || $[11] !== t5 || $[12] !== testId || $[13] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[7] = appearance;
        $[8] = iconColor;
        $[9] = label;
        $[10] = size;
        $[11] = t5;
        $[12] = testId;
        $[13] = textColor;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : ({ appearance: appearance, label: label = 'Jira Work Management', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const id = (0, $6JrSr.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $bd0fead550960ba8$var$svg({
            appearance: appearance,
            size: size,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};
module.exports["JiraWorkManagementLogo"] = $bd0fead550960ba8$export$56cadce97cc7cc;

});

parcelRegister("cwhx1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $2JKQ0 = parcelRequire("2JKQ0");


var $ihy5X = parcelRequire("ihy5X");


var $cPYuK = parcelRequire("cPYuK");

const $8398861367fbafe3$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $2JKQ0.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $2JKQ0.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cPYuK.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
  <svg viewBox="0 0 179 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
    <defs>
      <linearGradient x1="97.6553341%" y1="35.6591143%" x2="37.202032%" y2="75.4891864%" id="${id}-1">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="7%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
      <linearGradient x1="8.43371138%" y1="60.1495759%" x2="64.1161517%" y2="23.5790285%" id="${id}-2">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g stroke="none" stroke-width="1" fill-rule="nonzero">
      <path fill="${colors.iconColor}" d="M11.3881081,27.9242105 C12.4881804,26.8071817 13.1062496,25.2917664 13.1062496,23.7115789 C13.1062496,22.1313915 12.4881804,20.6159762 11.3881081,19.4989474 L11.3881081,19.4989474 L3.74837838,11.7621053 L0.273513514,15.2926316 C-0.0900771727,15.6625064 -0.0900771727,16.2617042 0.273513514,16.6315789 L11.3881081,27.9242105 L11.3881081,27.9242105 Z" fill-rule="nonzero"></path>
      <path fill="${colors.iconColor}" d="M22.5027027,15.2926316 L11.3881081,4 L11.3881081,4 L11.3539189,4.03473684 L11.3539189,4.03473684 C9.08852466,6.36456187 9.09963243,10.1156459 11.3787838,12.4315789 L19.0247297,20.1652632 L22.5027027,16.6315789 C22.8662934,16.2617042 22.8662934,15.6625064 22.5027027,15.2926316 Z" fill-rule="nonzero"></path>
      <path d="M11.3881081,12.4252632 C9.10895676,10.1093301 9.09784899,6.35824608 11.3632432,4.02842105 L3.43445946,12.0810526 L7.58067568,16.2936842 L11.3881081,12.4252632 Z" fill="url(#${id}-1)" fill-rule="nonzero"></path>
      <path fill="url(#${id}-2)" d="M15.1893243,15.6368421 L11.3881081,19.4989474 C12.4881804,20.6159762 13.1062496,22.1313915 13.1062496,23.7115789 C13.1062496,25.2917664 12.4881804,26.8071817 11.3881081,27.9242105 L19.3355405,19.8494737 L15.1893243,15.6368421 Z" fill-rule="nonzero"></path>
      <path fill="${colors.textColor}" d="M36.07,18.956 C36.07,20.646 35.394,21.842 33.418,21.842 C32.56,21.842 31.702,21.686 31,21.4 L31,23.662 C31.65,23.896 32.586,24.104 33.808,24.104 C37.032,24.104 38.41,21.946 38.41,18.8 L38.41,6.918 L36.07,6.918 L36.07,18.956 Z M41.894,7.568 C41.894,8.556 42.544,9.128 43.454,9.128 C44.364,9.128 45.014,8.556 45.014,7.568 C45.014,6.58 44.364,6.008 43.454,6.008 C42.544,6.008 41.894,6.58 41.894,7.568 Z M42.31,24 L44.546,24 L44.546,11 L42.31,11 L42.31,24 Z M47.926,24 L50.11,24 L50.11,16.33 C50.11,13.574 51.852,12.716 54.712,13.002 L54.712,10.818 C52.164,10.662 50.864,11.754 50.11,13.288 L50.11,11 L47.926,11 L47.926,24 Z M65.45,24 L65.45,21.66 C64.618,23.376 63.058,24.26 61.056,24.26 C57.598,24.26 55.856,21.322 55.856,17.5 C55.856,13.834 57.676,10.74 61.316,10.74 C63.214,10.74 64.67,11.598 65.45,13.288 L65.45,11 L67.686,11 L67.686,24 L65.45,24 Z M58.092,17.5 C58.092,20.62 59.34,22.18 61.654,22.18 C63.656,22.18 65.45,20.906 65.45,18.02 L65.45,16.98 C65.45,14.094 63.812,12.82 61.914,12.82 C59.392,12.82 58.092,14.484 58.092,17.5 Z M86.926,19.294 C86.926,16.226 84.898,15.056 81.284,14.146 C78.268,13.392 77.176,12.69 77.176,11.286 C77.176,9.726 78.502,8.946 80.738,8.946 C82.506,8.946 84.352,9.258 86.068,10.246 L86.068,7.906 C84.898,7.256 83.312,6.658 80.842,6.658 C76.864,6.658 74.836,8.634 74.836,11.286 C74.836,14.094 76.552,15.42 80.4,16.356 C83.65,17.136 84.586,17.942 84.586,19.45 C84.586,20.958 83.624,21.972 81.05,21.972 C78.788,21.972 76.344,21.374 74.758,20.542 L74.758,22.934 C76.084,23.61 77.618,24.26 80.92,24.26 C85.158,24.26 86.926,22.258 86.926,19.294 Z M95.09,24.26 C91.19,24.26 88.902,21.374 88.902,17.474 C88.902,13.574 91.19,10.74 95.09,10.74 C98.964,10.74 101.226,13.574 101.226,17.474 C101.226,21.374 98.964,24.26 95.09,24.26 Z M95.09,12.82 C92.308,12.82 91.086,15.004 91.086,17.474 C91.086,19.944 92.308,22.18 95.09,22.18 C97.846,22.18 99.042,19.944 99.042,17.474 C99.042,15.004 97.846,12.82 95.09,12.82 Z M106.92,9.622 C106.92,8.452 107.596,7.646 108.974,7.646 C109.494,7.646 109.988,7.698 110.378,7.776 L110.378,5.722 C109.988,5.618 109.546,5.514 108.87,5.514 C106.088,5.514 104.736,7.152 104.736,9.57 L104.736,11 L102.63,11 L102.63,13.08 L104.736,13.08 L104.736,24 L106.92,24 L106.92,13.08 L110.274,13.08 L110.274,11 L106.92,11 L106.92,9.622 Z M115.786,19.892 L115.786,13.08 L119.244,13.08 L119.244,11 L115.786,11 L115.786,8.244 L113.602,8.244 L113.602,11 L111.496,11 L111.496,13.08 L113.602,13.08 L113.602,19.944 C113.602,22.362 114.954,24 117.736,24 C118.412,24 118.854,23.896 119.244,23.792 L119.244,21.634 C118.854,21.712 118.36,21.816 117.84,21.816 C116.462,21.816 115.786,21.036 115.786,19.892 Z M125.432,24 L128.292,24 L130.528,17.708 L131.724,13.704 L132.92,17.708 L135.156,24 L138.016,24 L142.8,11 L140.33,11 L136.586,22.024 L132.79,11 L130.658,11 L126.862,22.024 L123.118,11 L120.648,11 L125.432,24 Z M153.538,24 L153.538,21.66 C152.706,23.376 151.146,24.26 149.144,24.26 C145.686,24.26 143.944,21.322 143.944,17.5 C143.944,13.834 145.764,10.74 149.404,10.74 C151.302,10.74 152.758,11.598 153.538,13.288 L153.538,11 L155.774,11 L155.774,24 L153.538,24 Z M146.18,17.5 C146.18,20.62 147.428,22.18 149.742,22.18 C151.744,22.18 153.538,20.906 153.538,18.02 L153.538,16.98 C153.538,14.094 151.9,12.82 150.002,12.82 C147.48,12.82 146.18,14.484 146.18,17.5 Z M159.154,24 L161.338,24 L161.338,16.33 C161.338,13.574 163.08,12.716 165.94,13.002 L165.94,10.818 C163.392,10.662 162.092,11.754 161.338,13.288 L161.338,11 L159.154,11 L159.154,24 Z M178.108,23.48 C177.042,24.052 175.404,24.26 174.078,24.26 C169.216,24.26 167.084,21.452 167.084,17.474 C167.084,13.548 169.268,10.74 173.22,10.74 C177.224,10.74 178.836,13.522 178.836,17.474 L178.836,18.488 L169.346,18.488 C169.658,20.698 171.088,22.128 174.156,22.128 C175.664,22.128 176.938,21.842 178.108,21.426 L178.108,23.48 Z M173.116,12.768 C170.75,12.768 169.554,14.302 169.32,16.564 L176.574,16.564 C176.444,14.146 175.352,12.768 173.116,12.768 Z" fill-rule="evenodd"></path>
    </g>
  </svg>`;
};
const $8398861367fbafe3$export$8869c52f95591fed = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { appearance: appearance, label: t1, size: t2, testId: testId, iconColor: t3, textColor: t4 } = t0;
    const label = t1 === undefined ? "Jira Software" : t1;
    const size = t2 === undefined ? (0, $2JKQ0.defaultLogoParams).size : t2;
    const iconColor = t3 === undefined ? (0, $2JKQ0.defaultLogoParams).iconColor : t3;
    const textColor = t4 === undefined ? (0, $2JKQ0.defaultLogoParams).textColor : t4;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const id = (0, $6JrSr.useId)();
    let t5;
    if ($[0] !== appearance || $[1] !== colorMode || $[2] !== iconColor || $[3] !== id || $[4] !== textColor) {
        t5 = $8398861367fbafe3$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id);
        $[0] = appearance;
        $[1] = colorMode;
        $[2] = iconColor;
        $[3] = id;
        $[4] = textColor;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== appearance || $[7] !== iconColor || $[8] !== label || $[9] !== size || $[10] !== t5 || $[11] !== testId || $[12] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: t5,
            testId: testId,
            textColor: textColor
        });
        $[6] = appearance;
        $[7] = iconColor;
        $[8] = label;
        $[9] = size;
        $[10] = t5;
        $[11] = testId;
        $[12] = textColor;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : ({ appearance: appearance, label: label = 'Jira Software', size: size = (0, $2JKQ0.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2JKQ0.defaultLogoParams).iconColor, textColor: textColor = (0, $2JKQ0.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const id = (0, $6JrSr.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihy5X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $8398861367fbafe3$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};
module.exports["JiraSoftwareLogo"] = $8398861367fbafe3$export$8869c52f95591fed;

});

parcelRegister("hcVQz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $b0bcd54bf057f7ca$export$667425256e2e7296 = (NewComponent)=>{
    return ({ size: size, ...props })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const Component = NewComponent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            size: size || 'medium',
            ...props
        });
    };
};
module.exports["tempSizeWrapper"] = $b0bcd54bf057f7ca$export$667425256e2e7296;

});

parcelRegister("lH46a", function(module, exports) {

var $kejsE = parcelRequire("kejsE");


const $500003af26d22cdb$export$7818df200941dbbf = (appearance, colorMode)=>{
    let iconColor = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode).iconColor;
    let textColor = (0, $kejsE.getColorsFromAppearance)(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};
module.exports["getColorsForLoom"] = $500003af26d22cdb$export$7818df200941dbbf;

});

parcelRegister("cPYuK", function(module, exports) {
// TODO: This is where we need to add tokens for all appearance color values
const $4a82bced5c33363c$export$362a25f017e2bc8a = (appearance, colorMode)=>{
    let iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = '#0052CC';
            iconGradientStop = '#2684FF';
            iconColor = '#2684FF';
            textColor = "var(--ds-text, #292A2E)";
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = '#0052CC';
            break;
        case 'neutral':
            iconGradientStart = '#344563';
            iconGradientStop = '#7A869A';
            iconColor = '#7A869A';
            textColor = '#505F79';
            atlassianLogoTextColor = '#505F79';
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
module.exports["getColorsFromAppearanceOldLogos"] = $4a82bced5c33363c$export$362a25f017e2bc8a;

});


$parcel$global.rlb("jZMUd")
//# sourceMappingURL=MainButtons.8845ded8.js.map
